<template>
    <v-container fluid ref="container" class="pb-0" style=" height: 100%; ">
        <v-col ref="details" class="ma-0 pa-0">
            <v-row
                style="background-color: #eeeeee; border-radius: 5px;"
                class="mt-1 mx-0 px-1"
            >
                <h2 class="mx-6 mt-1 py-2" style="color: #212121;">
                    INFORMATION
                </h2>
                <v-spacer />
                <v-icon
                    class="ma-2"
                    color="primary"
                    @click="showAssemblyInformation"
                    v-if="workOrder.assemblyWorkOrder && !isAnonymous"
                >
                    mdi-help
                </v-icon>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            class="ma-2"
                            color="primary"
                            @click="closureNotesReadDialog = true"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-text-box-outline
                        </v-icon>
                    </template>
                    <span>Show closure notes</span>
                </v-tooltip>
                <v-icon
                    class="ma-2"
                    color="primary"
                    @click="showInformation"
                    v-if="!showWOInfo"
                >
                    mdi-eye
                </v-icon>
                <v-icon
                    class="ma-2"
                    color="primary"
                    @click="showInformation"
                    v-else
                >
                    mdi-eye-off
                </v-icon>
                <v-tooltip bottom v-if="!isAnonymous">
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            class="ma-2"
                            color="primary"
                            @click="openAlertsDialog"
                            v-bind="attrs"
                            v-on="on"
                        >
                            mdi-alert-circle
                        </v-icon>
                    </template>
                    <span>View Alerts</span>
                </v-tooltip>
            </v-row>
            <v-row
                id="virtual-scroll-table"
                no-gutters
                v-show="showWOInfo"
                class="mt-3 px-2"
            >
                <v-col cols="4">
                    <div>
                        <div class="mt-4 d-flex justify-start">
                            <p>
                                <strong>ID: </strong>
                                {{ workOrder.code.split('-')[1] }}
                            </p>
                            <v-chip
                                :color="statusColor[workOrder.status]"
                                class="ml-2 mt-n1 white--text text-capitalize d-flex justify-center align-center"
                                style="min-width: 85px;"
                            >
                                {{ workOrder.status }}
                            </v-chip>
                            <strong
                                class="ml-2"
                                v-if="workOrder.assemblyWorkOrder != undefined"
                                >Type:
                            </strong>
                            <v-chip
                                :color="
                                    colorOption[
                                        workOrder.assemblyWorkOrder
                                            ? 'Assembly'
                                            : 'Production'
                                    ]
                                "
                                class="ml-2 mt-n1 white--text text-capitalize d-flex justify-center align-center"
                                style="cursor: pointer; min-width: 90px;"
                                v-if="workOrder.assemblyWorkOrder != undefined"
                                @click="openTypeDialog()"
                            >
                                {{
                                    workOrder.assemblyWorkOrder
                                        ? 'Assembly'
                                        : 'Production'
                                }}
                            </v-chip>
                        </div>

                        <p>
                            <strong>CREATION DATE: </strong
                            >{{
                                ` ${
                                    workOrder.createdOn
                                        ? formatDate(
                                              workOrder.createdOn.seconds ||
                                                  workOrder.createdOn._seconds
                                          )
                                        : ''
                                }`
                            }}
                        </p>
                        <p
                            v-if="
                                workOrder.productionEnd &&
                                    (workOrder.status == 'finished' ||
                                        workOrder.status == 'closed')
                            "
                        >
                            <strong>PRODUCTION END: </strong
                            >{{
                                ` ${
                                    workorder.productionEnd
                                        ? formatDate(
                                              workOrder.productionEnd.seconds ||
                                                  workOrder.productionEnd
                                                      ._seconds
                                          )
                                        : ''
                                }`
                            }}
                        </p>
                        <p class="text-capitalize">
                            <strong>CREATED BY: </strong>
                            {{ ` ${createdByName}` }}
                        </p>
                        <p class="text-capitalize">
                            <strong>PROJECT MANAGER:</strong
                            >{{ ` ${projectManagerName}` }}
                        </p>
                        <div
                            class="text-capitalize mb-1"
                            v-if="workOrder.assemblyWorkOrder"
                        >
                            <v-checkbox
                                v-if="
                                    permissionToFinishWO &&
                                        ['approved', 'finished'].includes(
                                            workOrder.status
                                        )
                                "
                                v-model="allowWoUpdates"
                                class="ma-0 pa-0 ml-0"
                                hide-details
                                label="Allow WO Updates"
                                :disabled="!permissionToFinishWO"
                                @change="onAllowWoUpdatesChange"
                            />
                            <div
                                class="d-flex align-center mb-1"
                                v-if="
                                    !isAnonymous &&
                                        workOrder.status !== 'inProgress'
                                "
                            >
                                <strong>
                                    ORIGIN WORK ORDERS:
                                    <span
                                        v-if="isOriginWorkOrdersFieldRequired"
                                        class="red--text"
                                        >*</span
                                    >
                                </strong>
                                <v-autocomplete
                                    class="ml-2"
                                    v-model="originWorkOrderCodes"
                                    :items="projectWorkOrderCodes"
                                    item-text="code"
                                    item-value="code"
                                    multiple
                                    chips
                                    small-chips
                                    :hide-details="
                                        !isOriginWorkOrdersFieldRequired
                                    "
                                    :rules="originWorkOrdersRules"
                                    placeholder="Select origin work orders"
                                    @change="onOriginWorkOrdersChange"
                                    :disabled="!canEditOriginWorkOrders"
                                    no-data-text="No work orders found"
                                />
                            </div>
                        </div>
                        <div class="d-flex" v-if="!isAnonymous">
                            <div class="d-flex align-center">
                                <strong>ATTACHED: </strong>
                            </div>
                            <div class="d-flex align-center flex-wrap">
                                <v-btn
                                    color="grey lighten-3"
                                    elevation="0"
                                    x-small
                                    class="ma-1 text-capitalize grey--text text--darken-1  "
                                    v-for="(file, i) in workOrder.attachments"
                                    :key="i"
                                >
                                    <span @click="openFileAttached(file)">{{
                                        file
                                    }}</span>
                                    <v-icon
                                        v-if="
                                            (workOrder.status == 'inProgress' ||
                                                workOrder.status ==
                                                    'rejected' ||
                                                workOrder.status == 'sent') &&
                                                !readOnlyWO
                                        "
                                        @click="deleteFile(file)"
                                        class="ml-1"
                                        small
                                    >
                                        mdi-close-circle
                                    </v-icon>
                                </v-btn>
                                <v-btn
                                    @click="openWorkOrderFiles"
                                    depressed
                                    fab
                                    x-small
                                    color="primary"
                                    class="ml-xl-2 ml-lg-2 ml-md-2 ml-sm-2"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected' ||
                                            workOrder.status == 'sent') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </v-col>
                <v-col
                    cols="12"
                    xl="4"
                    lg="4"
                    md="4"
                    class="pl-xl-2 pl-lg-2 pl-md-2"
                >
                    <div>
                        <v-textarea
                            v-model="workOrder.notes"
                            prepend-icon="mdi-text"
                            prefix="Description: "
                            hide-details
                            rows="1"
                            @blur="saveNotes"
                            :disabled="readOnlyWO"
                        >
                        </v-textarea>
                    </div>
                    <div>
                        <v-select
                            v-model="workOrder.classification"
                            :items="classificationOptions"
                            hide-details
                            prepend-icon="mdi-format-list-bulleted-type"
                            prefix="Classification: "
                            @change="saveClassification"
                            :disabled="classificationDisabled"
                        >
                        </v-select>
                    </div>
                    <div>
                        <v-textarea
                            v-model="workOrder.description"
                            prepend-icon="mdi-text-long"
                            prefix="Notes: "
                            hide-details
                            rows="1"
                            @blur="saveDescription"
                            :disabled="descriptionDisabled"
                        >
                        </v-textarea>
                    </div>
                    <div>
                        <v-autocomplete
                            v-model="woProductType"
                            :items="productTypes"
                            item-text="name"
                            return-object
                            hide-details
                            prepend-icon="mdi-tools"
                            prefix="Product Type: "
                            @change="saveProductType"
                            :clearable="false"
                            :disabled="
                                readOnlyWO ||
                                    loading ||
                                    !(
                                        workOrder.status === 'rejected' ||
                                        workOrder.status === 'inProgress' ||
                                        (workOrder.status === 'approved' &&
                                            updateWOProcessesPermission)
                                    )
                            "
                        >
                        </v-autocomplete>
                    </div>
                    <!--   Reprocess Checkbox -->
                    <div v-if="workOrder.reprocess" class="d-flex">
                        <p class="mt-6 mr-2 mb-0">
                            <strong>REPROCESS:</strong>
                        </p>
                        <v-checkbox
                            v-model="workOrder.reprocess"
                            hide-details
                            disabled
                        ></v-checkbox>
                    </div>
                    <!--   Warranty Checkbox -->
                    <div v-if="workOrder.reprocess" class="d-flex">
                        <p class="mt-6 mr-2 mb-0"><strong>WARRANTY:</strong></p>
                        <v-checkbox
                            v-model="workOrder.warranty"
                            hide-details
                            :disabled="
                                !'inProgress-rejected-sent-approved'.includes(
                                    workOrder.status
                                )
                            "
                            @click="updateWarranty"
                        ></v-checkbox>
                    </div>
                    <!-- Clean Production Fields Button -->
                    <!-- <div class="mt-4">
                        <v-btn
                            rounded
                            color="warning"
                            class="white--text"
                            @click="cleanProductionFields"
                            :loading="loadingCleanFields"
                            :disabled="loading"
                            small
                        >
                            <v-icon left small>mdi-broom</v-icon>
                            Clean Production Fields
                        </v-btn>
                    </div> -->
                </v-col>
                <v-spacer />
                <v-col cols="4" class="d-flex justify-end">
                    <canvas
                        id="qr"
                        @click="copyQRLink"
                        style="cursor: pointer;"
                        :title="'Click to copy link'"
                    ></canvas>
                </v-col>
            </v-row>
        </v-col>

        <v-row no-gutters class="mt-8">
            <v-col cols="12">
                <v-data-table
                    :headers="filteredHeaders"
                    :items="filterWorkOrders"
                    class="elevation-0"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                    :height="`${height}px`"
                    v-if="!workOrder.assemblyWorkOrder"
                    fixed-header
                    style="overflow-y: auto;"
                    item-key="partNumberId"
                    :item-class="getItemAlertRowClass"
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            :style="{ 'background-color': '#eeeeee' }"
                            class="mt-0 mx-0 pb-0"
                        >
                            <v-col cols="12" sm="4" class="d-flex mb-1 pb-0">
                                <h2 class="mx-4 mt-1">
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? 'ITEMS'
                                            : 'PRODUCTION ITEMS'
                                    }}
                                </h2>
                                <v-btn
                                    class="mt-1"
                                    small
                                    icon
                                    color="primary"
                                    @click="openDeleteAllItem"
                                    v-if="
                                        (workOrder.status == 'inProgress' ||
                                            workOrder.status == 'rejected') &&
                                            !readOnlyWO
                                    "
                                >
                                    <v-icon>mdi-delete-sweep-outline</v-icon>
                                </v-btn>
                            </v-col>
                            <v-spacer />
                            <v-col
                                cols="12"
                                sm="4"
                                class="d-flex justify-end"
                                v-if="
                                    (workOrder.status == 'inProgress' ||
                                        workOrder.status == 'rejected') &&
                                        !readOnlyWO
                                "
                            >
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    @click="openAddItem"
                                    :disabled="
                                        loading ||
                                            (workOrder.partNumbers &&
                                                Object.values(
                                                    workOrder.partNumbers
                                                ).length +
                                                    1 >
                                                    MAX_WORK_ORDER_ITEMS)
                                    "
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon>
                                        mdi-plus
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'NEW ITEM'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    @click="importFiles"
                                    :disabled="loading"
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon>
                                        mdi-login-variant
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'IMPORT'
                                    }}
                                </v-btn>
                                <v-btn
                                    rounded
                                    color="primary"
                                    class="mx-1"
                                    @click="openUploadFiles"
                                    :disabled="loading"
                                    :small="$vuetify.breakpoint.smAndDown"
                                >
                                    <v-icon>
                                        mdi-upload
                                    </v-icon>
                                    {{
                                        $vuetify.breakpoint.smAndDown
                                            ? ''
                                            : 'FILES'
                                    }}
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                sm="4"
                                class="d-flex justify-end px-0"
                                style="flex-wrap: wrap;"
                                v-if="
                                    !user.operatorRole &&
                                        (workOrder.status == 'approved' ||
                                            workOrder.status == 'finished')
                                "
                            >
                                <div class="d-flex justify-center pr-3">
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-1"
                                        :disabled="loading"
                                        @click="openMultipleProcesses"
                                        v-if="
                                            !user.operatorRole &&
                                                updateWOProcessesPermission &&
                                                workOrder.status == 'approved'
                                        "
                                        :small="$vuetify.breakpoint.smAndDown"
                                    >
                                        <v-icon>
                                            mdi-swap-vertical
                                        </v-icon>
                                        {{
                                            $vuetify.breakpoint.smAndDown
                                                ? ''
                                                : 'SET PROCESSES'
                                        }}
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-1"
                                        :disabled="loading"
                                        @click="openMultipleRegister"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                user.process
                                        "
                                        :small="$vuetify.breakpoint.smAndDown"
                                    >
                                        <v-icon class="mr-1">
                                            mdi-tools
                                        </v-icon>
                                        {{
                                            $vuetify.breakpoint.smAndDown
                                                ? ''
                                                : 'REGISTER ITEMS'
                                        }}
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-1"
                                        :disabled="loading"
                                        :small="$vuetify.breakpoint.smAndDown"
                                        @click="openMultipleSend"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                user.process
                                        "
                                    >
                                        <v-icon class="mr-1">
                                            mdi-send
                                        </v-icon>
                                        {{
                                            $vuetify.breakpoint.smAndDown
                                                ? ''
                                                : 'SEND ITEMS'
                                        }}
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-1"
                                        :disabled="loading"
                                        @click="openReceiveItems"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                user.process
                                        "
                                        :small="$vuetify.breakpoint.smAndDown"
                                    >
                                        <v-icon class="mr-1">
                                            mdi-database-arrow-down-outline
                                        </v-icon>
                                        {{
                                            $vuetify.breakpoint.smAndDown
                                                ? ''
                                                : 'RECEIVE ITEMS'
                                        }}
                                    </v-btn>
                                    <v-btn
                                        rounded
                                        color="primary"
                                        class="mx-1"
                                        :disabled="loading"
                                        @click="openMultipleQuality"
                                        v-if="
                                            markQualityRegistersPermission &&
                                                (workOrder.status ==
                                                    'approved' ||
                                                    workOrder.status ==
                                                        'finished')
                                        "
                                        :small="$vuetify.breakpoint.smAndDown"
                                    >
                                        <v-icon class="mr-1">
                                            mdi-check-bold
                                        </v-icon>
                                        {{
                                            $vuetify.breakpoint.smAndDown
                                                ? ''
                                                : 'QUALITY'
                                        }}
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </template>
                    <!-- HEADERS -->
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            class="py-2 mt-2"
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                            :style="{ width: '80px' }"
                        />
                    </template>
                    <template v-slot:[`header.processes`]="{ header }">
                        <div class="d-flex justify-center align-center">
                            <v-text-field
                                class="py-2 mt-2"
                                :label="header.text"
                                v-model="processToFilter"
                                dense
                                :style="{ width: '80px' }"
                            />
                            <v-spacer />
                            <v-menu rounded offset-y v-if="user.process">
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        depressed
                                    >
                                        <v-icon>mdi-sort</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        @click="
                                            sortByAvailable = !sortByAvailable
                                            sortByProduced = false
                                            sortByDelivered = false
                                            sortByPending = false
                                            sortByReleased = false
                                            sortByReprocess = false
                                            sortByRejected = false
                                        "
                                        :class="{
                                            'selected-item': sortByAvailable,
                                        }"
                                    >
                                        <v-list-item-title>
                                            Sort By Available
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            sortByAvailable = false
                                            sortByProduced = !sortByProduced
                                            sortByDelivered = false
                                            sortByPending = false
                                            sortByReleased = false
                                            sortByReprocess = false
                                            sortByRejected = false
                                        "
                                        :class="{
                                            'selected-item': sortByProduced,
                                        }"
                                    >
                                        <v-list-item-title>
                                            Sort By Produced
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            sortByAvailable = false
                                            sortByProduced = false
                                            sortByDelivered = !sortByDelivered
                                            sortByPending = false
                                            sortByReleased = false
                                            sortByReprocess = false
                                            sortByRejected = false
                                        "
                                        :class="{
                                            'selected-item': sortByDelivered,
                                        }"
                                    >
                                        <v-list-item-title>
                                            Sort By Delivered
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <template v-slot:[`header.status`]="{ header }">
                        <div class="d-flex justify-center align-center">
                            <p class="ma-0 pa-0 mr-2">
                                {{ header.text }}
                            </p>
                            <v-spacer />
                            <v-menu rounded offset-y>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        depressed
                                    >
                                        <v-icon>mdi-sort</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        @click="
                                            sortByPending = !sortByPending
                                            sortByReleased = false
                                            sortByReprocess = false
                                            sortByRejected = false
                                            sortByAvailable = false
                                            sortByProduced = false
                                            sortByDelivered = false
                                        "
                                        :class="{
                                            'selected-item': sortByPending,
                                        }"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#2b81d6"
                                                >mdi-circle</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Sort By Pending
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            sortByPending = false
                                            sortByReleased = !sortByReleased
                                            sortByReprocess = false
                                            sortByRejected = false
                                            sortByAvailable = false
                                            sortByProduced = false
                                            sortByDelivered = false
                                        "
                                        :class="{
                                            'selected-item': sortByReleased,
                                        }"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#2fbf56"
                                                >mdi-circle</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Sort By Released
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            sortByPending = false
                                            sortByReleased = false
                                            sortByReprocess = !sortByReprocess
                                            sortByRejected = false
                                            sortByAvailable = false
                                            sortByProduced = false
                                            sortByDelivered = false
                                        "
                                        :class="{
                                            'selected-item': sortByReprocess,
                                        }"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#ffa41d"
                                                >mdi-circle</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Sort By Reprocess
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="
                                            sortByPending = false
                                            sortByReleased = false
                                            sortByReprocess = false
                                            sortByRejected = !sortByRejected
                                            sortByAvailable = false
                                            sortByProduced = false
                                            sortByDelivered = false
                                        "
                                        :class="{
                                            'selected-item': sortByRejected,
                                        }"
                                    >
                                        <v-list-item-icon>
                                            <v-icon color="#FF2610"
                                                >mdi-circle</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Sort By Rejected
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.id`]="{ index }">
                        <p class="my-0">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.mass`]="{ item }">
                        <div class="d-flex justify-end">
                            <p class="my-0">
                                {{ item.mass.toFixed(1) }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.paintingArea`]="{ item }">
                        <div class="d-flex justify-end">
                            <p class="my-0">
                                {{ item.paintingArea.toFixed(1) }} (m2)
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.pieceLength`]="{ item }">
                        <div class="d-flex justify-end">
                            <p class="my-0">
                                {{
                                    item.pieceLength != null &&
                                    item.pieceLength !== ''
                                        ? Number(item.pieceLength).toFixed(1) +
                                          ' (mm)'
                                        : '-'
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.pieceWidth`]="{ item }">
                        <div class="d-flex justify-end">
                            <p class="my-0">
                                {{
                                    item.pieceWidth != null &&
                                    item.pieceWidth !== ''
                                        ? Number(item.pieceWidth).toFixed(1) +
                                          ' (mm)'
                                        : '-'
                                }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.finishAndUCCode`]="{ item }">
                        <div class="d-flex align-center justify-center">
                            <p class="my-0">
                                <v-tooltip right>
                                    <template v-slot:activator="{ on }">
                                        <span
                                            v-on="on"
                                            :style="{ cursor: 'pointer' }"
                                        >
                                            {{
                                                item.finishAndUCCode &&
                                                    finishAndUcCodeData &&
                                                    finishAndUcCodeData[
                                                        item.finishAndUCCode
                                                    ]?.name
                                            }}
                                        </span>
                                    </template>
                                    <span>
                                        {{
                                            (item.finishAndUCCode &&
                                                finishAndUcCodeData &&
                                                finishAndUcCodeData[
                                                    item.finishAndUCCode
                                                ]?.description) ||
                                                'Does not have description'
                                        }}
                                    </span>
                                </v-tooltip>
                            </p>
                            <!-- TEMPORARY: tempEditFinishAndUCCode -->
                            <TempEditFinishAndUCCode
                                v-if="editSettingsPermission"
                                :item="item"
                                :work-order="workOrder"
                                :user="user"
                                :setting-finish="settingFinish"
                                :finish-and-uc-code-data="finishAndUcCodeData"
                                @updated="replaceItem"
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <p class="my-0" :style="{ 'max-width': '250px' }">
                            {{ item.description }}
                        </p>
                    </template>

                    <template v-slot:[`item.notes`]="{ item }">
                        <p class="my-0" :style="{ 'max-width': '250px' }">
                            {{ item.notes }}
                        </p>
                    </template>
                    <template v-slot:[`item.processes`]="{ item }">
                        <div
                            v-for="(process, index) in item.productionInfo"
                            :key="process.id"
                        >
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <p class="my-0 text-left" v-on="on">
                                        <span
                                            :class="{
                                                'font-weight-bold': user.processes.includes(
                                                    process.id
                                                ),
                                            }"
                                        >
                                            {{ process.name }} </span
                                        >: {{ process.available }} -
                                        {{ process.produced || 0 }} -
                                        {{
                                            index ==
                                                item.processes.length - 1 &&
                                            workOrder.assemblyWorkOrder !=
                                                undefined
                                                ? 'NA'
                                                : process.delivered
                                        }}
                                    </p>
                                </template>
                                <span>
                                    {{ process.name }}: <br />
                                    Available =
                                    {{ process.available || 0 }} ({{
                                        ((process.received || 0) * 100) /
                                            item.quantity
                                    }}%)<br />
                                    Produced =
                                    {{ process.produced || 0 }} ({{
                                        ((process.produced || 0) * 100) /
                                            item.quantity
                                    }}%)<br />
                                    Delivered =
                                    {{
                                        index == item.processes.length - 1
                                            ? 'NA'
                                            : process.delivered
                                    }}
                                    ({{
                                        index == item.processes.length - 1
                                            ? 'NA'
                                            : ((process.delivered || 0) * 100) /
                                              item.quantity
                                    }}%)
                                </span>
                            </v-tooltip>
                        </div>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <div
                            v-if="
                                item.processes.includes(qualityProcess.id) ||
                                    workOrder.assemblyWorkOrder == undefined
                            "
                        >
                            <v-tooltip right>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        x-small
                                        icon
                                        class="mr-1"
                                        color="white"
                                        :style="{
                                            'background-color': '#2b81d6',
                                        }"
                                        v-on="on"
                                    >
                                        <p class="my-0">
                                            {{ calculateQualityPending(item) }}
                                        </p>
                                    </v-btn>
                                    <v-btn
                                        x-small
                                        icon
                                        class="mr-1"
                                        color="white"
                                        :style="{
                                            'background-color': '#2fbf56',
                                        }"
                                        v-on="on"
                                    >
                                        <p class="my-0">
                                            {{ calculateReleasedQty(item) }}
                                        </p>
                                    </v-btn>
                                    <v-btn
                                        x-small
                                        icon
                                        class="mr-1"
                                        color="white"
                                        :style="{
                                            'background-color': '#ffa41d',
                                        }"
                                        v-on="on"
                                    >
                                        <p class="my-0">
                                            {{ calculateReprocessQty(item) }}
                                        </p>
                                    </v-btn>
                                    <v-btn
                                        x-small
                                        icon
                                        class="mr-1"
                                        color="white"
                                        :style="{
                                            'background-color': '#FF2610',
                                        }"
                                        v-on="on"
                                    >
                                        <p class="my-0">
                                            {{ calculateRejectedQty(item) }}
                                        </p>
                                    </v-btn>
                                </template>
                                <span>
                                    Pending :
                                    {{ calculateQualityPending(item) || 0 }}
                                    <br />
                                    Released :
                                    {{ calculateReleasedQty(item) }} <br />
                                    Reprocess :
                                    {{ calculateReprocessQty(item) }} <br />
                                    Rejected :
                                    {{ calculateRejectedQty(item) }} <br />
                                </span>
                            </v-tooltip>
                        </div>
                        <span v-else>-</span>
                    </template>
                    <template v-slot:[`item.files`]="{ item }">
                        <div
                            class="d-flex justify-center my-0"
                            v-if="item.files != undefined"
                        >
                            <a
                                v-if="
                                    item.files.includes(
                                        `${item.partNumber}.pdf`
                                    )
                                "
                                class="mx-1"
                                @click="loadFiles(item, 'pdf')"
                            >
                                PDF
                            </a>
                            <a
                                v-if="
                                    item.files.includes(
                                        `${item.partNumber}.dxf`
                                    )
                                "
                                class="mx-1"
                                @click="loadFiles(item, 'dxf')"
                            >
                                DXF
                            </a>
                            <a
                                v-if="
                                    item.files.includes(
                                        `${item.partNumber}.stp`
                                    )
                                "
                                class="mx-1"
                                @click="loadFiles(item, 'stp')"
                            >
                                STP
                            </a>
                        </div>
                    </template>
                    <template v-slot:[`item.actions`]="{ item }">
                        <div>
                            <v-menu rounded offset-y>
                                <template v-slot:activator="{ attrs, on }">
                                    <v-btn
                                        icon
                                        v-bind="attrs"
                                        v-on="on"
                                        small
                                        depressed
                                    >
                                        <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item
                                        @click="editItem(item)"
                                        v-if="
                                            (workOrder.status == 'inProgress' ||
                                                workOrder.status ==
                                                    'rejected' ||
                                                workOrder.status == 'sent' ||
                                                workOrder.status ==
                                                    'approved') &&
                                                !readOnlyWO
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-pencil</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Edit Item
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openAddItemFiles(item)"
                                        v-if="
                                            (workOrder.status == 'inProgress' ||
                                                workOrder.status ==
                                                    'rejected') &&
                                                !readOnlyWO
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-upload</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Add Item Files
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openDeleteItem(item)"
                                        v-if="
                                            (workOrder.status == 'inProgress' ||
                                                workOrder.status ==
                                                    'rejected') &&
                                                !readOnlyWO
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-trash-can</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Delete Item
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="copyItem(item)"
                                        v-if="
                                            (workOrder.status == 'inProgress' ||
                                                workOrder.status ==
                                                    'rejected') &&
                                                !readOnlyWO
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Copy Item
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openArrangeProcesses(item)"
                                        v-if="
                                            workOrder.status == 'approved' &&
                                                !readOnlyWO &&
                                                !user.operatorRole &&
                                                updateWOProcessesPermission
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-swap-vertical</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Arrange Processes
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="registerProduction(item)"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                !readOnlyWO &&
                                                item &&
                                                item.processes.length > 0 &&
                                                activateActions(item)
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-tools</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Register Production
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="sendToPrevProcess(item)"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                !readOnlyWO &&
                                                item &&
                                                item.processes.length > 0 &&
                                                activateActions(item) &&
                                                item.processes[0] !=
                                                    user.process.id
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon
                                                >mdi-arrow-left-circle-outline</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Return To Previous Process
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="sendToNextProcess(item)"
                                        v-if="
                                            (workOrder.status == 'approved' ||
                                                workOrder.status ==
                                                    'finished') &&
                                                !readOnlyWO &&
                                                item &&
                                                item.processes.length > 0 &&
                                                activateActions(item)
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-send</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Send To Next Process
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="registerQuality(item)"
                                        v-if="
                                            !readOnlyWO &&
                                                item &&
                                                item.processes.length > 0 &&
                                                markQualityRegistersPermission &&
                                                (workOrder.status ==
                                                    'approved' ||
                                                    workOrder.status ==
                                                        'finished')
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-check-bold</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Register Quality
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openProductionLog(item)"
                                        v-if="
                                            item &&
                                                item.processes.length > 0 &&
                                                workOrder.status != 'inProgress'
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon
                                                >mdi-book-cog-outline</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Production Log
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openDeliveryLog(item)"
                                        v-if="
                                            item &&
                                                workOrder.status != 'inProgress'
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon
                                                >mdi-book-arrow-right-outline</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Delivery Log
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openQualityLog(item)"
                                        v-if="
                                            item &&
                                                item.processes.length > 0 &&
                                                workOrder.status != 'inProgress'
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon
                                                >mdi-book-check-outline</v-icon
                                            >
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Quality Log
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item
                                        @click="openDeleteItem(item)"
                                        v-if="
                                            workOrder.status == 'approved' &&
                                                !readOnlyWO &&
                                                permissionToCancelWO &&
                                                (!item.production ||
                                                    item.production.length == 0)
                                        "
                                        :disabled="
                                            item.production &&
                                                item.production.length > 0
                                        "
                                    >
                                        <v-list-item-icon>
                                            <v-icon>mdi-trash-can</v-icon>
                                        </v-list-item-icon>
                                        <v-list-item-title>
                                            Delete Item
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                    </template>
                    <!--FOOTER-->
                    <template v-slot:[`body.append`]>
                        <tr>
                            <td class="font-weight-bold text-center"></td>
                            <td class="font-weight-bold text-center">
                                TOTAL
                            </td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold text-right">
                                {{ totalMass.toFixed(1) }} (kgs)
                            </td>
                            <td class="font-weight-bold text-right">
                                {{ totalPaintingArea.toFixed(1) }} (m2)
                            </td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold text-right">
                                {{ totalQuantity }}
                            </td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold"></td>
                            <td class="font-weight-bold"></td>
                            <td
                                class="font-weight-bold"
                                v-if="
                                    workOrder.status == 'approved' ||
                                        workOrder.status == 'closed' ||
                                        workOrder.status == 'finished'
                                "
                            ></td>
                        </tr>
                    </template>
                </v-data-table>
                <AssemblyItems
                    v-else
                    :workOrder="workOrder"
                    :readOnlyWO="readOnlyWO"
                    :height="height"
                    :settingFinish="settingFinish"
                    :partNumbers="partNumbers"
                    :isAnonymous="user?.name === 'AnonymousSession'"
                    @close="closeDialog"
                    @editItem="editItem"
                    @openAddItem="openAddItem"
                    @copyItem="copyItem"
                    @openAddItemFiles="openAddItemFiles"
                    @openUploadFiles="openUploadFiles"
                    @openDeleteItem="openDeleteItem"
                    @openDeleteAllItem="openDeleteAllItem"
                    @openArrangeProcesses="openArrangeProcesses"
                    @sendToNextProcess="sendToNextProcess"
                    @sendToPrevProcess="sendToPrevProcess"
                    @registerProduction="registerProduction"
                    @openMultipleProcesses="openMultipleProcesses"
                    @openMultipleRegister="openMultipleRegister"
                    @openMultipleSend="openMultipleSend"
                    @registerQuality="registerQuality"
                    @openMultipleQuality="openMultipleQuality"
                    @openProductionLog="openProductionLog"
                    @openDeliveryLog="openDeliveryLog"
                    @openQualityLog="openQualityLog"
                    @importFiles="importFiles"
                    @openReceiveItems="openReceiveItems"
                    @replaceItem="replaceItem"
                    class="ma-0 pa-0"
                />
            </v-col>
        </v-row>

        <v-row class="ma-0 pa-0" ref="buttons">
            <v-row
                no-gutters
                v-if="
                    (workOrder.status == 'inProgress' ||
                        workOrder.status == 'rejected') &&
                        !readOnlyWO
                "
                class="mt-5"
            >
                <v-col cols="12" class="d-flex">
                    <v-btn
                        v-if="
                            workOrder.projectManager == user.id ||
                                workOrder.createdBy.id == user.id ||
                                (user.permissions &&
                                    user.permissions.includes('deleteWO'))
                        "
                        rounded
                        color="red"
                        class="white--text"
                        @click="openDeleteWorkOrder"
                    >
                        DELETE
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        @click="sendWO"
                        :loading="loading"
                        :disabled="
                            notItemsCreated() || isOriginWorkOrdersRequired()
                        "
                    >
                        SEND
                    </v-btn>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-if="workOrder.status == 'sent' && !readOnlyWO"
                class="mt-5"
                cols="12"
            >
                <v-col cols="12" class="d-flex">
                    <v-btn
                        :disabled="
                            (!permissionToRejectWO &&
                                !projectManagerCollaboratorCondition) ||
                                !workOrder.projectManager == user.id
                        "
                        rounded
                        color="red"
                        class="white--text"
                        @click="openRejectWO"
                        :loading="loading"
                    >
                        REJECT
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        @click="approve"
                        :loading="loading"
                        :disabled="
                            (workOrder.assemblyWorkOrder &&
                                originWorkOrderCodes.length < 1 &&
                                this.formatDate(
                                    workOrder.sentDate?.seconds ||
                                        workOrder.sentDate?._seconds
                                ) > this.deployDate) ||
                                (workOrder.projectManager != user.id &&
                                    !projectManagerCollaboratorCondition)
                        "
                    >
                        APPROVE
                    </v-btn>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-if="workOrder.status == 'approved' && !readOnlyWO"
                class="mt-5"
            >
                <v-col cols="12" class="d-flex">
                    <v-btn
                        v-if="permissionToCancelWO"
                        rounded
                        color="black"
                        @click="openCancelDialog = true"
                        :loading="loading"
                        :disabled="processesInitiated()"
                        class="white--text text-capitalize"
                    >
                        CANCEL
                    </v-btn>
                    <v-btn
                        rounded
                        color="red"
                        class="white--text ml-4"
                        @click="openRejectWO"
                        :loading="loading"
                        :disabled="
                            processesInitiated() ||
                                !permissionToRejectApprovedWo
                        "
                    >
                        REJECT
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="#5c5c5c"
                        @click="openFinishDialog"
                        :loading="loading"
                        class="white--text text-capitalize"
                        :disabled="loading || !permissionToFinishWO"
                    >
                        FINISH
                    </v-btn>
                </v-col>
            </v-row>
            <v-row
                no-gutters
                v-if="workOrder.status == 'finished' && !readOnlyWO"
                class="mt-5"
            >
                <v-col cols="12" class="d-flex">
                    <v-btn
                        rounded
                        color="primary"
                        @click="returnToApprovedDialog = true"
                        :loading="loading"
                        class="white--text text-capitalize"
                        :disabled="loading || !permissionToFinishWO"
                    >
                        RETURN TO APPROVED
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="#ff9c0a"
                        @click="closingDialog = true"
                        :loading="loading"
                        class="white--text text-capitalize"
                        :disabled="disableCloseProcess()"
                    >
                        CLOSE
                    </v-btn>
                </v-col>
            </v-row>
        </v-row>
        <!--Item Form-->
        <v-dialog
            v-model="openItemForm"
            persistent
            max-width="800px"
            :retain-focus="false"
        >
            <ItemForm
                v-if="openItemForm"
                :workOrder="workOrder"
                :partNumbers="partNumbers"
                :item="selectedItem"
                :originalItem="originalItem"
                :createForm="createForm"
                :settingProcesses="settingProcesses"
                :settingFinish="settingFinish"
                :OCs="OCs"
                :positions="positions"
                @replaceItem="replaceItem"
                @close="closeAddItem"
                @addItem="addItem"
            />
        </v-dialog>
        <!--Assembly Item Form-->
        <v-dialog
            v-model="openAssemblyItemForm"
            persistent
            max-width="800px"
            :retain-focus="false"
        >
            <AssemblyItemForm
                v-if="openAssemblyItemForm"
                :workOrder="workOrder"
                :partNumbers="partNumbers"
                :item="selectedItem"
                :originalItem="originalItem"
                :createForm="createForm"
                :settingProcesses="settingProcesses"
                :settingFinish="settingFinish"
                :OCs="OCs"
                :positions="positions"
                @replaceItem="replaceItem"
                @close="closeAddItem"
                @addItem="addItem"
            />
        </v-dialog>
        <!--OC and Position Form-->
        <v-dialog
            v-model="openOcAndPositionForm"
            persistent
            max-width="800px"
            :retain-focus="false"
        >
            <OcAndPositionForm
                v-if="openOcAndPositionForm"
                :workOrder="workOrder"
                :item="selectedItem"
                :originalItem="originalItem"
                :OCs="OCs"
                :positions="positions"
                @replaceItem="replaceItem"
                @close="closeOcAndPositionForm"
            />
        </v-dialog>
        <!--Add Item Files-->
        <v-dialog
            v-model="openItemFiles"
            persistent
            max-width="600px"
            :retain-focus="false"
        >
            <AddItemFiles
                v-if="openItemFiles"
                :partNumber="selectedItem.partNumber"
                :partNumbers="partNumbers"
                :workOrder="workOrder"
                :selectedItem="selectedItem"
                :settingProcesses="settingProcesses"
                :settingFinish="settingFinish"
                @openPartNumbersNotFound="openPartNumbersNotFound"
                @addItems="addItems"
                @addFiles="addFiles"
                @close="closeAddItemFiles"
            />
            <v-alert
                v-if="partNumbersNotFound.length > 0"
                type="error"
                :style="{ position: 'absolute', bottom: '0px', right: '0px' }"
            >
                <div class="d-flex">
                    <p class="my-0">
                        The following part numbers do not belong to the project:
                        <br />
                        {{ partNumbersNotFound.join(', ') }}
                    </p>
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="partNumbersNotFound = []"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </div>
            </v-alert>
        </v-dialog>
        <!--Upload Files-->
        <v-dialog
            v-model="uploadFiles"
            persistent
            max-width="800px"
            :retain-focus="false"
        >
            <UploadFiles
                v-if="uploadFiles"
                :workOrder="workOrder"
                @addFiles="addFiles"
                @close="closeUploadFiles"
            />
        </v-dialog>
        <!--ALERT-->
        <v-alert
            v-if="activateAlert"
            type="success"
            color="primary"
            :style="{ position: 'absolute', right: '0px', bottom: '0px' }"
        >
            <v-row no-gutters>
                <v-col cols="11">
                    <p class="my-0">{{ alertMessage }}</p>
                </v-col>
                <v-col cols="1">
                    <v-btn
                        small
                        icon
                        class="mt-n1"
                        @click="activateAlert = false"
                    >
                        <v-icon>
                            mdi-close
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-alert>
        <!--Delete Item-->
        <v-dialog
            v-model="deleteWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="deleteWarning">
                <v-card-title class="text-h5">Delete Items</v-card-title>
                <v-card-text>
                    Are you sure you want to perform this operation ?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteItem">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="removeItems"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Delete Work Order-->
        <v-dialog
            v-model="deleteWorkOrderWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="deleteWorkOrderWarning">
                <v-card-title class="text-h5">Delete Work Order</v-card-title>
                <v-card-text>
                    Are you sure you want to delete this work order?
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeDeleteWorkOrder">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteWorkOrder"
                        text
                        color="error"
                        :loading="loading"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Reject Work Orders-->
        <v-dialog
            v-model="rejectWOForm"
            persistent
            max-width="600px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="rejectWOForm">
                <v-card-title class="text-h5">Reject</v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="selectedRejectionReason"
                                :items="settingsRejectionReasons"
                                item-text="reason"
                                item-value="id"
                                label="Select Rejection Reason"
                                required
                                hide-details
                                :rules="[rules.required]"
                                :return-object="true"
                                no-data-text="No matching reasons found"
                                clearable
                            />
                        </v-col>

                        <v-col cols="12">
                            Write an extra note
                        </v-col>
                    </v-row>
                    <v-form v-model="validRejectForm">
                        <v-row no-gutters class="mb-2 mt-n5">
                            <v-col cols="12">
                                <v-textarea
                                    v-model="rejectedNotes"
                                    rows="2"
                                    hide-details
                                    label="Extra Note"
                                    prepend-icon="mdi-text"
                                >
                                </v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-checkbox v-model="projectManagerMistake">
                                    <template v-slot:label>
                                        Project Manager Mistake
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeRejectWO">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="rejectWO"
                        text
                        color="error"
                        :loading="loading"
                        :disabled="loading || !selectedRejectionReason"
                    >
                        Reject
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--ADD FILES-->
        <v-dialog
            :retain-focus="false"
            v-model="workOrderFiles"
            persistent
            max-width="400px"
        >
            <v-card v-if="workOrderFiles">
                <v-card-title class="text-h5">Add File</v-card-title>
                <v-card-text>
                    <v-file-input
                        class="mt-3 pb-0"
                        v-model="file"
                        label="File"
                    ></v-file-input>
                </v-card-text>
                <v-card-actions class="pb-3 pt-0">
                    <v-btn
                        text
                        color="secondary"
                        @click="workOrderFiles = false"
                    >
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="saveFile"
                        color="primary"
                        :loading="loadingFiles"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--ARRANGE PROCESSES-->
        <v-dialog
            :retain-focus="false"
            v-model="arrangeProcesses"
            persistent
            max-width="450px"
        >
            <ArrangeProcesses
                v-if="arrangeProcesses"
                :item="selectedItem"
                :originalItem="originalItem"
                :settingsProcesses="settingProcesses"
                :workOrder="workOrder"
                :multipleItemSelect="false"
                @closeDialog="closeArrangeProcesses"
                @saveProcesses="saveProcesses"
            />
        </v-dialog>
        <!--REGISTER PRODUCTION-->
        <v-dialog
            :retain-focus="false"
            v-model="productionDialog"
            persistent
            max-width="500px"
        >
            <RegisterProduction
                v-if="productionDialog"
                :item="selectedItem"
                :workOrder="workOrder"
                :settings="settingProcesses"
                :user="user"
                @closeDialog="closeRegisterProduction"
            />
        </v-dialog>
        <!--RETURN TO THE PREV PROCESS-->
        <v-dialog
            :retain-focus="false"
            v-model="prevProcessDialog"
            persistent
            max-width="500px"
        >
            <PrevProcess
                v-if="prevProcessDialog"
                :item="selectedItem"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeSendToPrevProcess"
            />
        </v-dialog>
        <!--MOVE TO THE NEXT PROCESS-->
        <v-dialog
            :retain-focus="false"
            v-model="processDialog"
            persistent
            max-width="1100px"
        >
            <NextProcess
                v-if="processDialog"
                :item="selectedItem"
                :workOrder="workOrder"
                :user="user"
                :sendOperation="sendOperation"
                @closeDialog="closeSendToNextProcess"
            />
        </v-dialog>
        <!--RECEIVE ITEMS-->
        <v-dialog
            :retain-focus="false"
            v-model="receiveItemsDialog"
            persistent
            :max-width="dialogMaxWidth"
        >
            <ReceiveItems
                v-if="receiveItemsDialog"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeReceiveItemsDialog"
            />
        </v-dialog>
        <!--Multiple Register-->
        <v-dialog
            :retain-focus="false"
            v-model="multipleRegisterDialog"
            persistent
            max-width="900px"
        >
            <MultipleRegister
                v-if="multipleRegisterDialog"
                :workOrder="workOrder"
                :user="user"
                :settings="settingProcesses"
                :forAssemblyOrder="forAssemblyOrder"
                @closeDialog="closeMultipleRegister"
                @replaceItems="closeRegisterProduction"
            />
        </v-dialog>
        <!--Multiple Send-->
        <v-dialog
            :retain-focus="false"
            v-model="multipleSendDialog"
            persistent
            max-width="900px"
        >
            <MultipleSend
                v-if="multipleSendDialog"
                :workOrder="workOrder"
                :user="user"
                :processes="settingProcesses"
                @closeDialog="closeMultipleSend"
            />
        </v-dialog>
        <!--Multiple Processes-->
        <v-dialog
            :retain-focus="false"
            v-model="multipleProcessDialog"
            persistent
            max-width="900px"
        >
            <MultipleProcesses
                v-if="multipleProcessDialog"
                :processes="settingProcesses"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeMultipleProcesses"
            />
        </v-dialog>
        <!-- Close Work Order Process -->
        <v-dialog
            v-model="closingDialog"
            persistent
            max-width="500"
            :retain-focus="false"
            ><WorkOrderClosingProcess
                v-if="closingDialog"
                :workOrder="workOrder"
                :closeWorkOrderPermission="closeWorkOrderPermission"
                :closeWOWithPendingItemsPermission="
                    closeWOWithPendingItemsPermission
                "
                :settingProcesses="settingProcesses"
                :partNumbers="partNumbers"
                @closeDialog="closeWoClosingProcess"
            ></WorkOrderClosingProcess
        ></v-dialog>
        <!-- Return To Approved Dialog -->
        <v-dialog
            v-model="returnToApprovedDialog"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="returnToApprovedDialog">
                <v-card-title class="text-h5">
                    Return Work Order to Approved
                </v-card-title>
                <v-card-text>
                    Are you sure you want to return this work order to approved
                    status?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="returnToApprovedDialog = false"
                        rounded
                    >
                        NO
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="returnToApproved"
                        text
                        color="primary"
                        rounded
                        :loading="loading"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--Delete Item-->
        <v-dialog
            v-model="openWarning"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openWarning">
                <v-card-title class="text-h5">
                    {{ title }} Work Order {{ workOrder.code }}</v-card-title
                >
                <v-card-text>
                    {{ message }}
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeWarning" rounded>
                        NO
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="warningAction"
                        text
                        color="error"
                        rounded
                        :loading="loading"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="forceFinishDialog"
            persistent
            max-width="520px"
            :retain-focus="false"
        >
            <v-card v-if="forceFinishDialog" :loading="loading">
                <v-card-title class="text-h5"
                    >Force finish — {{ workOrder.code }}</v-card-title
                >
                <v-card-text>
                    <p class="mb-2">
                        You are about to finish the work order without
                        completing the production of all processes, are you sure
                        to carry out this operation?
                    </p>
                    <v-textarea
                        v-model="forceFinishNotesText"
                        outlined
                        label="Notes (required)"
                        rows="4"
                        :rules="[rules.required]"
                    />
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="forceFinishDialog = false"
                        rounded
                    >
                        Cancel
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        text
                        color="error"
                        :loading="loading"
                        @click="confirmForceFinish"
                        rounded
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <WoClosureNotes
            :value="closureNotesReadDialog"
            :workOrder="workOrder"
            :users="users"
            @close="closureNotesReadDialog = false"
        />
        <!-- Suggested Qty Warning -->
        <v-dialog
            v-model="suggestedQtyWarning"
            persistent
            max-width="800px"
            :retain-focus="false"
        >
            <SuggestedQtyDialog
                v-if="suggestedQtyWarning"
                :selectedItem="selectedItem"
                :suggestedQtyAlerts="suggestedQtyAlerts"
                @closeDialog="closeSuggestedQtyWarning"
            ></SuggestedQtyDialog>
        </v-dialog>
        <!--Cancel WO-->
        <v-dialog
            v-model="openCancelDialog"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openCancelDialog">
                <v-card-title class="text-h5">
                    Cancel Work Order {{ workOrder.code }}</v-card-title
                >
                <v-card-text>
                    Are you sure you want to cancel this work order ?
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="secondary"
                        @click="openCancelDialog = false"
                        rounded
                    >
                        NO
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="deleteWorkOrder"
                        text
                        color="error"
                        rounded
                        :loading="loading"
                    >
                        YES
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--QUALITY PROCESS-->
        <v-dialog
            :retain-focus="false"
            v-model="qualityDialog"
            persistent
            max-width="450px"
        >
            <QualityProcess
                v-if="!approveOrRejectPartsPermission"
                :item="selectedItem"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeQualityProcess"
            />
            <RegisterQualityPerProcess
                v-else
                :item="selectedItem"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeQualityProcess"
            />
        </v-dialog>
        <!--MULTIPLE QUALITY PROCESS-->
        <v-dialog
            :retain-focus="false"
            v-model="multipleQualityDialog"
            persistent
            max-width="1400px"
        >
            <MultipleQualityProcess
                v-if="multipleQualityDialog && !approveOrRejectPartsPermission"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeMultipleQualityProcess"
            />
            <MultipleQualityPerProcess
                v-else-if="multipleQualityDialog"
                :workOrder="workOrder"
                :user="user"
                @closeDialog="closeMultipleQualityProcess"
            />
        </v-dialog>
        <!--ITEM LOG-->
        <v-dialog
            :retain-focus="false"
            v-model="itemLogDialog"
            persistent
            max-width="1200px"
        >
            <ItemLog
                v-if="itemLogDialog"
                :viewType="viewType"
                :users="users"
                :selectedItem="selectedItem"
                :workOrder="workOrder"
                @closeDialog="itemLogDialog = false"
            />
        </v-dialog>
        <!-- Type Dialog -->
        <v-dialog
            v-model="typeDialog"
            persistent
            max-width="400px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="typeDialog">
                <v-card-title class="text-h5"
                    >Change Work Order Type</v-card-title
                >
                <v-card-text>
                    <v-combobox
                        v-model="workOrderType"
                        :items="options"
                        hide-details
                        label="Select Type"
                    >
                    </v-combobox>
                </v-card-text>
                <v-card-actions>
                    <v-btn text color="secondary" @click="closeTypeDialog()">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="updateWorkOrderType()"
                        text
                        color="error"
                        :loading="loading"
                        :disabled="!workOrderType || workOrderType == ''"
                    >
                        SAVE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--ASSEMBLY INFORMATION-->
        <v-dialog
            :retain-focus="false"
            v-model="assemblyInfoDialog"
            persistent
            max-width="1200px"
        >
            <AssemblyInformation
                v-if="assemblyInfoDialog"
                :workOrder="workOrder"
                @closeDialog="closeAssemblyInformation"
            />
        </v-dialog>
        <!--ALERTS LIST-->
        <AlertsList
            ref="alertsList"
            v-model="alertsDialog"
            :workOrder="workOrder"
            :readOnlyWO="readOnlyWO"
            :make-changes-opening="makeChangesOpening"
            :opening-make-changes-alert-id="openingMakeChangesAlertId"
            @create-alert="openCreateAlertDialog"
            @view-alert="viewAlert"
            @edit-alert="handleEditAlertFromList"
            @resolve-alert="handleResolveAlertFromList"
            @make-changes-alert="handleMakeChangesAlertFromList"
            @approve-alert="handleApproveAlertFromList"
            @delete-alert="handleDeleteAlertFromList"
            @delete-non-executable-alert="
                handleDeleteNonExecutableAlertFromList
            "
        />
        <!--ALERT FORM-->
        <v-dialog
            :retain-focus="false"
            v-model="alertFormDialog"
            persistent
            max-width="800px"
        >
            <AlertForm
                v-if="alertFormDialog"
                :workOrder="workOrder"
                :alert="selectedAlert"
                :createForm="!selectedAlert"
                @close="closeAlertForm"
                @reload="reloadAlerts"
            />
        </v-dialog>
        <!--ALERT TIMELINE-->
        <AlertTimeline
            v-if="selectedAlert"
            v-model="timelineDialog"
            :alert="selectedAlert"
            :can-edit-alert="canEditAlert(selectedAlert)"
            :can-resolve-alert="canResolveAlert(selectedAlert)"
            :can-make-changes="canMakeChanges(selectedAlert)"
            :make-changes-opening="makeChangesOpening"
            :can-approve-alert="canApproveAlert(selectedAlert)"
            @edit="handleTimelineEdit"
            @resolve="handleTimelineResolve"
            @make-changes="handleTimelineMakeChanges"
            @approve="handleTimelineApprove"
        />
        <!--ALERT REVIEW (SUPERVISOR RESOLVE/FORWARD)-->
        <v-dialog
            v-model="supervisorReviewDialog"
            max-width="600px"
            scrollable
            persistent
        >
            <v-card v-if="selectedAlert">
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="supervisorReviewDialog = false"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">Review Alert</h2>
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-form ref="supervisorForm" v-model="supervisorFormValid">
                        <v-radio-group
                            v-model="supervisorAction"
                            :rules="[rules.required]"
                        >
                            <v-radio
                                label="Resolve Alert"
                                value="resolve"
                            ></v-radio>
                            <v-radio
                                label="Forward to PM/Designer"
                                value="forward"
                            ></v-radio>
                        </v-radio-group>
                        <v-textarea
                            v-if="supervisorAction === 'resolve'"
                            v-model="supervisorNotes"
                            label="Notes"
                            rows="4"
                            auto-grow
                            class="mt-4"
                            :rules="[rules.required]"
                        ></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        :loading="actionLoading"
                        color="primary"
                        rounded
                        :disabled="!supervisorFormValid || actionLoading"
                        @click="submitSupervisorReview"
                    >
                        SUBMIT
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--ALERT MAKE CHANGES-->
        <AlertChangesDialog
            v-if="selectedAlert && selectedAlert.workOrder && makeChangesDialog"
            v-model="makeChangesDialog"
            :OCs="OCs"
            :positions="positions"
            :settingProcesses="settingProcesses"
            :settingFinish="settingFinish"
            :alert="selectedAlert"
            :workOrder="selectedAlert.workOrder"
            @reload="reloadAlerts"
        />
        <!--ALERT APPROVE/REJECT-->
        <v-dialog
            v-model="approveDialog"
            max-width="600px"
            scrollable
            persistent
        >
            <v-card v-if="selectedAlert">
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="approveDialog = false"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">Approve/Reject Changes</h2>
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-form ref="approveForm" v-model="approveFormValid">
                        <v-radio-group
                            v-model="approveAction"
                            :rules="[rules.required]"
                        >
                            <v-radio
                                label="Approve Changes"
                                value="approve"
                            ></v-radio>
                            <v-radio
                                label="Reject Changes"
                                value="reject"
                            ></v-radio>
                            <v-radio
                                label="Resolve without applying changes"
                                value="resolve_without_apply"
                            ></v-radio>
                        </v-radio-group>
                        <v-textarea
                            v-model="approveNotes"
                            label="Notes"
                            rows="4"
                            auto-grow
                            class="mt-4"
                        ></v-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        :loading="actionLoading"
                        color="primary"
                        rounded
                        :disabled="!approveFormValid || actionLoading"
                        @click="submitApprove"
                    >
                        SUBMIT
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--DELETE NON-EXECUTABLE ALERT CONFIRMATION-->
        <v-dialog
            v-model="deleteNonExecutableDialog"
            max-width="450px"
            persistent
        >
            <v-card>
                <v-card-title class="text-h6">
                    Delete non-executable alert
                </v-card-title>
                <v-card-text>
                    The work order no longer exists. Do you want to delete this
                    alert from the list?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="deleteNonExecutableDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn
                        color="error"
                        :loading="actionLoading"
                        @click="confirmDeleteNonExecutableAlert"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--DELETE ALERT CONFIRMATION-->
        <v-dialog v-model="deleteAlertDialog" max-width="450px" persistent>
            <v-card>
                <v-card-title class="text-h6">
                    Delete alert
                </v-card-title>
                <v-card-text>
                    Are you sure you want to delete this alert?
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="deleteAlertDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn
                        color="error"
                        :loading="actionLoading"
                        @click="confirmDeleteAlert"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <NotAvailablePartNumbers
            v-model="notAvailablePartNumbersDialog"
            :items="notAvailablePartNumbers"
        />
    </v-container>
</template>

<script>
import moment from 'moment'
import API from '@/services/api'
import { createdByLabel } from './WOMethods.js'
import { mapMutations } from 'vuex'
import qrious from 'qrious'
import _ from 'lodash'
import { firestore } from '@/services/firebase'
import { loadImage, deleteImage } from '@/helpers/imageHandler.js'
import { saveFile } from '@/services/storage/saveFile.js'
import { deleteFile } from '@/services/storage/deleteFile.js'
import { openFile } from '@/services/storage/openFile.js'
import alertActionsMixin from '@/mixins/alertActionsMixin'
import { MAX_WORK_ORDER_ITEMS } from '@/constants/workOrderLimits'

export default {
    name: 'WOGeneralInfo',
    mixins: [alertActionsMixin],
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        readOnlyWO: {
            type: Boolean,
            default: () => false,
        },
        isAnonymous: {
            type: Boolean,
            default: () => false,
        },
    },
    components: {
        ItemForm: () => import('@/components/WorkOrders/ItemForm.vue'),
        AssemblyItemForm: () =>
            import('@/components/WorkOrders/AssemblyItemForm.vue'),
        OcAndPositionForm: () =>
            import('@/components/WorkOrders/OcAndPositionForm.vue'),
        AddItemFiles: () => import('@/components/WorkOrders/AddItemFiles.vue'),
        UploadFiles: () => import('@/components/WorkOrders/UploadFiles.vue'),
        ArrangeProcesses: () =>
            import('@/components/WorkOrders/ArrangeProcesses.vue'),
        NextProcess: () => import('@/components/WorkOrders/NextProcess.vue'),
        ReceiveItems: () => import('@/components/WorkOrders/ReceiveItems.vue'),
        PrevProcess: () => import('@/components/WorkOrders/PrevProcess.vue'),
        RegisterProduction: () =>
            import('@/components/WorkOrders/RegisterProduction.vue'),
        MultipleProcesses: () =>
            import('@/components/WorkOrders/MultipleProcesses.vue'),
        MultipleSend: () => import('@/components/WorkOrders/MultipleSend.vue'),
        MultipleRegister: () =>
            import('@/components/WorkOrders/MultipleRegister.vue'),
        QualityProcess: () =>
            import('@/components/WorkOrders/QualityProcess.vue'),
        MultipleQualityProcess: () =>
            import('@/components/WorkOrders/MultipleQualityProcess.vue'),
        MultipleQualityPerProcess: () =>
            import('@/components/WorkOrders/MultipleQualityPerProcess.vue'),
        ItemLog: () => import('@/components/WorkOrders/ItemLog.vue'),
        AssemblyItems: () =>
            import('@/components/WorkOrders/AssemblyItems.vue'),
        WorkOrderClosingProcess: () =>
            import('@/components/WorkOrders/WorkOrderClosingProcess.vue'),
        SuggestedQtyDialog: () =>
            import('@/components/WorkOrders/SuggestedQtyDialog.vue'),
        AssemblyInformation: () =>
            import('@/components/WorkOrders/AssemblyInformation.vue'),
        AlertsList: () => import('@/components/WorkOrders/AlertsList.vue'),
        // TEMPORARY: remove when temp finish edit feature is retired
        TempEditFinishAndUCCode: () =>
            import(
                '@/components/WorkOrders/tempEditFinishAndUCCode/TempEditFinishAndUCCode.vue'
            ),
        AlertForm: () => import('@/components/WorkOrders/AlertForm.vue'),
        AlertTimeline: () =>
            import('@/components/WorkOrders/AlertTimeline.vue'),
        AlertChangesDialog: () =>
            import('@/components/WorkOrders/AlertChangesDialog.vue'),
        RegisterQualityPerProcess: () =>
            import('@/components/WorkOrders/RegisterQualityPerProcess.vue'),
        WoClosureNotes: () =>
            import('@/components/WorkOrders/WoClosureNotes.vue'),
        NotAvailablePartNumbers: () =>
            import('@/components/WorkOrders/NotAvailablePartNumbers.vue'),
    },
    inject: {
        approveWO: {
            from: 'approveWO',
            default() {
                return null
            },
        },
        pendingWoFieldSaves: {
            from: 'pendingWoFieldSaves',
            default: () => ({
                description: false,
                notes: false,
                localValues: {},
            }),
        },
    },
    data: () => ({
        MAX_WORK_ORDER_ITEMS,
        multipleRegisterDialog: false,
        openCancelDialog: false,
        workOrderFiles: false,
        createForm: false,
        originalItem: {},
        deleteWorkOrderWarning: false,
        deleteWarning: false,
        alertMessage: '',
        activateAlert: false,
        uploadFiles: false,
        selectedItem: {},
        openItemFiles: false,
        openItemForm: false,
        openAssemblyItemForm: false,
        descriptionSavePromise: null,
        notesSavePromise: null,
        openOcAndPositionForm: false,
        loading: false,
        projectManagerName: undefined,
        rejectWOForm: false,
        rejectedNotes: undefined,
        projectManagerMistake: false,
        validRejectForm: false,
        headers: [
            {
                text: 'ID',
                value: 'id',
                align: 'center',
                sortable: false,
                width: 50,
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'MASS',
                value: 'mass',
                align: 'right',
                sortable: false,
            },
            {
                text: 'PAINTING AREA',
                value: 'paintingArea',
                align: 'right',
                sortable: false,
            },
            {
                text: 'LENGTH',
                value: 'pieceLength',
                align: 'right',
                sortable: false,
            },
            {
                text: 'WIDTH',
                value: 'pieceWidth',
                align: 'right',
                sortable: false,
            },
            {
                text: 'FINISH & UC CODE',
                value: 'finishAndUCCode',
                align: 'center',
                sortable: false,
            },
            {
                text: 'QTY',
                value: 'quantity',
                align: 'right',
                sortable: false,
            },
            {
                text: 'NOTES',
                value: 'notes',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PROCESSES',
                value: 'processes',
                align: 'left',
                sortable: false,
            },
            {
                text: 'FILES',
                value: 'files',
                align: 'center',
                sortable: false,
            },
            {
                text: 'OC',
                value: 'oc',
                align: 'left',
                sortable: false,
            },
            {
                text: 'POSITION',
                value: 'costPosition',
                align: 'left',
                sortable: false,
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                align: 'center',
                sortable: false,
            },
        ],
        statusColor: {
            sent: '#FF9800',
            approved: '#27BC4F',
            production: '#FFC000',
            rejected: 'red',
            closed: 'primary',
            inProgress: '#9E9FA0',
            finished: '#5c5c5c',
        },
        colorOption: {
            Production: '#2a7fd5',
            Assembly: '#1b5289',
        },
        height: 0,
        partNumbers: [],
        partNumbersNotFound: [],
        companyId: JSON.parse(localStorage.getItem('company')),
        settingProcesses: undefined,
        settingFinish: undefined,
        removeAll: false,
        file: null,
        loadingFiles: false,
        prevNotes: null,
        prevClassification: null,
        prevDescription: null,
        arrangeProcesses: false,
        user: {},
        processDialog: false,
        productionDialog: false,
        rules: {
            required: v => !!v || 'The value is required',
        },
        productionInfo: [],
        openWarning: false,
        multipleProcessDialog: false,
        multipleSendDialog: false,
        permissionToCancelWO: false,
        message: '',
        permissionToRejectWO: false,
        permissionToRejectApprovedWo: false,
        permissionToApproveWO: false,
        permissionToFinishWO: false,
        // TEMPORARY: remove when temp finish edit feature is retired
        editSettingsPermission: false,
        packingDialog: false,
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        readyForPackingProcess: {
            id: 'readyForPacking',
            name: 'Ready for packing',
        },
        packingProcess: {
            id: 'packing',
            name: 'Packing',
        },
        prevProcessDialog: false,
        qualityDialog: false,
        multipleQualityDialog: false,
        viewType: null,
        itemLogDialog: false,
        users: [],
        processToFilter: undefined,
        partNumberToFilter: undefined,
        sortByAvailable: false,
        sortByProduced: false,
        sortByDelivered: false,
        sortByPending: false,
        sortByReleased: false,
        sortByReprocess: false,
        sortByRejected: false,
        updateWOProcessesPermission: false,
        markQualityRegistersPermission: false,
        closeWorkOrderPermission: false,
        closeWOWithPendingItemsPermission: false,
        approveOrRejectPartsPermission: false,
        height2: 0,
        sendOperation: false,
        notAvailablePartNumbersDialog: false,
        notAvailablePartNumbers: [],
        dialogMaxWidth: '1000px',
        options: ['Production', 'Assembly'],
        typeDialog: false,
        workOrderType: '',
        OCs: [],
        positions: [],
        showWOInfo: false,
        title: '',
        receiveItemsDialog: false,
        productTypes: [],
        prevProductType: [],
        woProductType: undefined,
        closingDialog: false,
        forceFinishDialog: false,
        closureNotesReadDialog: false,
        forceFinishNotesText: '',
        returnToApprovedDialog: false,
        suggestedQtysPerPl: {},
        suggestedQtyAlerts: [],
        suggestedQtyWarning: false,
        settingsRejectionReasons: [],
        selectedRejectionReason: null,
        settingRejectionReasonsId: '',
        assemblyInfoDialog: false,
        alertsDialog: false,
        alertFormDialog: false,
        currentUserId: JSON.parse(localStorage.getItem('userId')),
        allowWoUpdates: false,
        originWorkOrderCodes: [],
        projectWorkOrderCodes: [],
        classificationOptions: ['Nacional', 'Exportación', 'ES'],
        forAssemblyOrder: false,
        loadingCleanFields: false,
        finishAndUcCodeData: {},
        restricionDate: '2026-02-15',
        workOrderAlerts: [],
        alertsUnsubscribe: null,
        deployDate: '02/25/2026',
        _partNumbersInitialLoad: true,
        blockedStatuses: ['approved', 'finished', 'closed', 'deleted'],
        projectManagerCollaboratorCondition: false,
    }),
    watch: {
        'workOrder.partNumbers': {
            handler() {
                if (this._partNumbersInitialLoad || !this.workOrder.items) {
                    this._partNumbersInitialLoad = false
                    return
                }
                this.workOrder.items.forEach(item => {
                    item.productionInfo = this.calculateFinished(item)
                })
            },
        },
        workOrder: async function() {
            if (this.partNumbers?.length) {
                this.setUpdatedData()
            }
            if (
                (this.selectedItem?.id || this.selectedItem?.partNumberId) &&
                (this.processDialog || this.productionDialog)
            ) {
                const updated = this.workOrder.items?.find(
                    i =>
                        i.id === this.selectedItem.id ||
                        i.partNumberId === this.selectedItem.partNumberId
                )
                if (updated) {
                    this.selectedItem = _.cloneDeep(updated)
                }
            }
        },
        partNumbers: {
            handler() {
                if (this.partNumbers?.length) {
                    this.setUpdatedData()
                }
            },
        },
    },
    computed: {
        createdByName() {
            return createdByLabel(this.workOrder && this.workOrder.createdBy)
        },
        filteredHeaders() {
            if (this.user?.name === 'AnonymousSession') {
                return this.headers.filter(header => header.value !== 'actions')
            }
            return this.headers
        },
        classificationDisabled() {
            return (
                this.readOnlyWO ||
                !this.workOrder ||
                this.blockedStatuses.includes(this.workOrder.status)
            )
        },
        descriptionDisabled() {
            return (
                this.readOnlyWO ||
                !this.workOrder ||
                this.blockedStatuses.includes(this.workOrder.status)
            )
        },
        filterWorkOrders() {
            let conditions = []
            let items = this.workOrder.items ? this.workOrder.items : []
            if (this.processToFilter) {
                conditions.push(this.filterByProcess)
            }
            if (this.partNumberToFilter) {
                conditions.push(this.filterByPartNumber)
            }
            if (conditions.length > 0) {
                return items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }

            if (
                ((this.sortByAvailable ||
                    this.sortByProduced ||
                    this.sortByDelivered) &&
                    this.user.process) ||
                this.sortByPending ||
                this.sortByReleased ||
                this.sortByReprocess ||
                this.sortByRejected
            ) {
                const auxItems = _.cloneDeep(items)
                const sortedItems = this.sort(auxItems)
                return sortedItems
            } else if (
                !this.sortByAvailable &&
                !this.sortByProduced &&
                !this.sortByDelivered &&
                !this.sortByPending &&
                !this.sortByReleased &&
                !this.sortByReprocess &&
                !this.sortByRejected
            ) {
                items.sort((a, b) => {
                    const last4DigitsA = parseInt(a.partNumber.slice(-4), 10)
                    const last4DigitsB = parseInt(b.partNumber.slice(-4), 10)
                    return last4DigitsA - last4DigitsB
                })

                return items
            }
            return items
        },
        validateOrders() {
            return !(
                this.workOrder.items?.filter(
                    item => item.files && item.files.length > 0
                ).length > 0
            )
        },
        totalMass() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator + item.mass * item.quantity,
                      0
                  )
                : 0
        },
        totalPaintingArea() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator + item.paintingArea * item.quantity,
                      0
                  )
                : 0
        },
        totalPieceLength() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator +
                          (Number(item.pieceLength) || 0) * item.quantity,
                      0
                  )
                : 0
        },
        totalPieceWidth() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) =>
                          accumulator +
                          (Number(item.pieceWidth) || 0) * item.quantity,
                      0
                  )
                : 0
        },
        totalQuantity() {
            return this.workOrder.items
                ? this.workOrder.items.reduce(
                      (accumulator, item) => accumulator + +item.quantity,
                      0
                  )
                : 0
        },
        canQualityManageRejectedReprocess() {
            return (
                this.markQualityRegistersPermission &&
                this.workOrder?.reprocess === true &&
                this.workOrder?.status === 'rejected'
            )
        },
        canEditOriginWorkOrders() {
            // Can edit if allowWoUpdates is enabled
            if (this.allowWoUpdates) {
                return true
            }
            // Or if order is in inProgress, rejected, or sent status
            // and user is the creator or project manager
            const editableStatuses = ['sent', 'rejected']
            if (editableStatuses.includes(this.workOrder.status)) {
                if (
                    this.workOrder.status === 'rejected' &&
                    this.canQualityManageRejectedReprocess
                ) {
                    return true
                }
                const isCreator =
                    this.workOrder.createdBy?.id === this.user.id ||
                    this.workOrder.createdBy === this.user.id
                const isProjectManager =
                    this.workOrder.projectManager === this.user.id ||
                    this.workOrder.project?.projectManager === this.user.id
                return isCreator || isProjectManager
            }
            return false
        },
        isOriginWorkOrdersFieldRequired() {
            if (
                this.workOrder.status === 'inProgress' ||
                this.workOrder.status === 'sent' ||
                this.workOrder.status === 'rejected'
            ) {
                return false
            }

            // A partir del 30 de enero de 2025, es obligatorio tener al menos una origin work order
            // para assembly work orders
            const requiredDate = new Date(this.restricionDate)
            const currentDate = new Date()

            // Si la fecha actual es anterior a la fecha requerida,
            // o si la fecha de envío de la orden es anterior al 2026-02-25 no es requerido
            if (
                currentDate < requiredDate ||
                !(
                    this.workOrder.sentDate?.seconds ||
                    this.workOrder.sentDate?._seconds
                ) ||
                this.formatDate(
                    this.workOrder.sentDate?.seconds ||
                        this.workOrder.sentDate?._seconds
                ) < this.deployDate
            ) {
                return false
            }

            // Solo es requerido si es assembly work order
            return this.workOrder.assemblyWorkOrder === true
        },
        originWorkOrdersRules() {
            if (!this.isOriginWorkOrdersFieldRequired) {
                return []
            }
            return [
                v => {
                    if (!v || !Array.isArray(v) || v.length === 0) {
                        return 'At least one origin work order is required'
                    }
                    return true
                },
            ]
        },
    },
    async created() {
        // Get companyId for anonymous users from route query
        const companyId = this.$route.query.companyId || this.companyId
        this.partNumbers = await API.getPartNumbers(
            this.workOrder.projectId,
            null,
            companyId
        )
        this.setUpdatedData()
    },
    async mounted() {
        try {
            this.loading = true
            this.showInformation()
            this.prevNotes = this.workOrder.notes
            this.prevProductType = this.workOrder.productType
            this.prevClassification = this.workOrder.classification
            this.prevDescription = this.workOrder.description

            // set project manager
            let projectManager = undefined
            if (typeof this.workOrder.project?.projectManager == 'string') {
                projectManager = await API.getUser(
                    this.workOrder.project.projectManager
                )
            } else {
                projectManager = this.workOrder.project?.projectManager
            }
            this.projectManagerName = projectManager?.name || ''
            const {
                data: { user },
            } = await API.getMyInfo()

            // set user processes
            user.processes = []
            if (user.process?.length > 0) {
                user.process.forEach(process => {
                    user.processes.push(process.id)
                })
            }

            this.user = user
            this.canApproveAlerts = !!(
                user.permissions &&
                user.permissions.includes('approveProductionAlerts')
            )

            this.projectManagerCollaboratorCondition =
                user.role &&
                user.role.toLowerCase() === 'project manager' &&
                this.workOrder.project?.collaborators?.includes(user.id)

            // Update companyId for anonymous users from route query
            if (
                user.name === 'AnonymousSession' &&
                this.$route.query.companyId
            ) {
                this.companyId = this.$route.query.companyId
            }

            this.updateWOProcessesPermission = this.user.permissions.includes(
                'updateWOProcesses'
            )

            this.markQualityRegistersPermission = this.user.permissions.includes(
                'markQualityRegisters'
            )

            // close wo permission
            this.closeWorkOrderPermission = this.user.permissions.includes(
                'closeWO'
            )

            // close wo with pending items permission
            this.closeWOWithPendingItemsPermission = this.user.permissions.includes(
                'closeWOWithPendingItems'
            )

            // Get companyId for request (use route query for anonymous users)
            const companyIdForRequest =
                user.name === 'AnonymousSession' && this.$route.query.companyId
                    ? this.$route.query.companyId
                    : this.companyId

            const {
                data: { users },
            } = await API.getLiteUsers(
                companyIdForRequest ? { companyId: companyIdForRequest } : {}
            )
            this.users = users
            // retrieve permission to cancel a WO
            this.permissionToCancelWO = user.permissions.includes('cancelWO')
            this.permissionToRejectWO = user.permissions.includes('rejectWO')
            this.permissionToRejectApprovedWo = user.permissions.includes(
                'rejectApprovedWO'
            )
            this.permissionToApproveWO = user.permissions.includes('approvedWO')
            this.permissionToFinishWO = user.permissions.includes('finishWO')
            this.approveOrRejectPartsPermission = user.permissions.includes(
                'approveOrRejectParts'
            )
            // TEMPORARY: remove when temp finish edit feature is retired
            this.editSettingsPermission = user.permissions.includes(
                'editSettings'
            )
            // qr code
            this.qrLink = `${process.env.VUE_APP_CLIENT_HOST}/work-orders/main-work-orders?orderId=${this.workOrder.id}&companyId=${this.companyId}&code=${this.workOrder.code}`
            new qrious({
                element: document.getElementById('qr'),
                value: this.qrLink,
            })
            await this.setOrderData()

            if (
                this.workOrder.status == 'approved' ||
                this.workOrder.status == 'finished' ||
                this.workOrder.status == 'closed'
            ) {
                this.headers.splice(9, 0, {
                    text: 'STATUS',
                    value: 'status',
                    align: 'center',
                    sortable: false,
                    width: 100,
                })
            }
            this.workOrderType = this.workOrder.assemblyWorkOrder
                ? 'Assembly'
                : 'Production'

            //this.quotes = await API.getProjectQuotes(this.workOrder.project.id)

            // get all OCs and all positions per OC
            const companyIdForOCS =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : this.companyId
            const { positions, OCs } = await API.getOCsAndPositions(
                this.workOrder.project.id,
                companyIdForOCS
            )

            this.OCs = OCs
            this.positions = positions
            //get project work order codes only in assembly work orders
            if (this.workOrder.assemblyWorkOrder) {
                // Get companyId for request (use route query for anonymous users)
                const companyIdForProjectWOCodes =
                    this.user?.name === 'AnonymousSession' &&
                    this.$route.query.companyId
                        ? this.$route.query.companyId
                        : this.companyId
                this.projectWorkOrderCodes = await API.getProjectWorkOrderCodes(
                    this.workOrder.project.id,
                    companyIdForProjectWOCodes
                )
                //filter current work order code from project work order codes
                this.projectWorkOrderCodes = this.projectWorkOrderCodes.filter(
                    wo => wo.code !== this.workOrder.code
                )
            }

            this.setUpdatedData()

            // get packing lists and verify the suggested qtys in wo partNumbers
            // Get companyId for request (use route query for anonymous users)
            const companyIdForPackingLists =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : this.companyId
            const packingLists = await API.getWOPackingLists({
                workOrderId: this.workOrder.id,
                workOrderCode: this.workOrder.code,
                companyId: companyIdForPackingLists,
            })
            if (packingLists.length > 0) {
                packingLists.forEach(pl => {
                    if (pl.packages?.length > 0) {
                        pl.packages.forEach(plPackage => {
                            if (plPackage.items?.length > 0) {
                                plPackage.items.forEach(packageItem => {
                                    if (
                                        packageItem.suggestedQty > 0 &&
                                        packageItem.workOrder ==
                                            this.workOrder.code
                                    ) {
                                        // initialize if not exist
                                        if (!this.suggestedQtysPerPl[pl.code]) {
                                            this.suggestedQtysPerPl[
                                                pl.code
                                            ] = {}
                                        }
                                        if (
                                            !this.suggestedQtysPerPl[pl.code][
                                                packageItem.partNumberId
                                            ]
                                        ) {
                                            this.suggestedQtysPerPl[pl.code][
                                                packageItem.partNumberId
                                            ] = 0
                                        }
                                        this.suggestedQtysPerPl[pl.code][
                                            packageItem.partNumberId
                                        ] += +packageItem.suggestedQty || 0
                                    }
                                })
                            }
                        })
                    }
                })
            }
            await this.loadWorkOrderAlerts()
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    beforeDestroy() {
        if (this.alertsUnsubscribe) {
            this.alertsUnsubscribe()
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        initializeOriginWorkOrders() {
            const codes = this.extractOriginWorkOrderCodes(
                this.workOrder.originWorkOrders
            )
            this.originWorkOrderCodes = this.sanitizeOriginWorkOrderCodes(codes)
            this.allowWoUpdates = Boolean(this.workOrder.allowWoUpdates)
        },
        async loadWorkOrderAlerts() {
            try {
                this.alertsUnsubscribe = firestore
                    .collection('companies')
                    .doc(this.companyId)
                    .collection('alerts')
                    .doc(this.workOrder.id)
                    .onSnapshot(
                        snapshot => {
                            if (snapshot.exists) {
                                const data = snapshot.data()
                                this.workOrderAlerts = data?.alerts || []
                            } else {
                                this.workOrderAlerts = []
                            }
                        },
                        error => {
                            console.error('Error listening to alerts:', error)
                        }
                    )
            } catch (error) {
                console.error('Error setting up alerts listener:', error)
                this.workOrderAlerts = []
            }
        },
        getItemAlertSummary(item) {
            const partNumberId = item.partNumberId || item.id
            const relevantAlerts = Object.values(this.workOrderAlerts).filter(
                alert => {
                    if (
                        !alert.selectedPartNumbers ||
                        !Array.isArray(alert.selectedPartNumbers)
                    ) {
                        return false
                    }
                    return alert.selectedPartNumbers.some(
                        pn => pn.id === partNumberId
                    )
                }
            )

            const summary = {
                hasAlerts: relevantAlerts.length > 0,
                total: relevantAlerts.length,
                open: 0,
                pendingApproval: 0,
                resolved: 0,
                allResolved: false,
            }

            relevantAlerts.forEach(alert => {
                if (alert.status === 'resolved') {
                    summary.resolved++
                } else if (alert.status === 'pending_approval') {
                    summary.pendingApproval++
                } else {
                    summary.open++
                }
            })

            summary.allResolved =
                summary.resolved > 0 &&
                summary.open === 0 &&
                summary.pendingApproval === 0

            return summary
        },
        getItemAlertRowClass(item) {
            if (this.isAnonymous) return ''
            const summary = this.getItemAlertSummary(item)
            if (!summary.hasAlerts) return ''

            if (summary.pendingApproval > 0) {
                return 'alert-pending-approval-row'
            }
            if (summary.open > 0) {
                return 'alert-open-row'
            }
            if (summary.allResolved && summary.total > 0) {
                return 'alert-resolved-row'
            }
            return ''
        },
        extractOriginWorkOrderCodes(originWorkOrders = []) {
            return (originWorkOrders || []).map(origin => {
                if (!origin) {
                    return null
                }
                if (typeof origin === 'string') {
                    return origin
                }
                if (typeof origin === 'object') {
                    return origin.code || origin.id || origin
                }
                return null
            })
        },
        sanitizeOriginWorkOrderCodes(codes = []) {
            const sanitized = []
            codes.forEach(code => {
                if (typeof code !== 'string') {
                    return
                }
                const trimmed = code.trim()
                if (!trimmed) {
                    return
                }
                if (!sanitized.includes(trimmed)) {
                    sanitized.push(trimmed)
                }
            })
            return sanitized
        },
        async onAllowWoUpdatesChange(value) {
            if (!this.permissionToFinishWO) {
                this.$nextTick(() => {
                    this.allowWoUpdates = !value
                })
                return
            }
            this.workOrder.allowWoUpdates = value
            try {
                await API.updateWorkOrderAllowWoUpdates({
                    workOrderId: this.workOrder.id,
                    allowWoUpdates: value,
                })
            } catch (error) {
                // Revert on error
                this.$nextTick(() => {
                    this.allowWoUpdates = !value
                    this.workOrder.allowWoUpdates = !value
                })
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async onOriginWorkOrdersChange(values) {
            if (!this.canEditOriginWorkOrders) {
                // Reset to original values if updates are not allowed
                this.$nextTick(() => {
                    this.originWorkOrderCodes = this.sanitizeOriginWorkOrderCodes(
                        this.extractOriginWorkOrderCodes(
                            this.workOrder.originWorkOrders
                        )
                    )
                })
                return
            }

            // Since item-value="code", values should be an array of strings (codes)
            // But handle both cases: strings directly or objects with code property
            let codes = []
            if (Array.isArray(values)) {
                codes = values
                    .map(value => {
                        if (typeof value === 'string') {
                            return value
                        }
                        if (typeof value === 'object' && value !== null) {
                            return value.code || value.id || value
                        }
                        return null
                    })
                    .filter(code => code !== null)
            } else if (values) {
                // Handle single value (shouldn't happen with multiple, but just in case)
                codes =
                    typeof values === 'string'
                        ? [values]
                        : [values.code || values.id || values]
            }

            const sanitized = this.sanitizeOriginWorkOrderCodes(codes)

            // Filter to only include codes that exist in projectWorkOrderCodes
            const validCodes = sanitized.filter(code => {
                return this.projectWorkOrderCodes.some(wo => wo.code === code)
            })

            // Update the model with valid codes
            this.$nextTick(() => {
                this.originWorkOrderCodes = validCodes
            })

            // Update workOrder object
            this.workOrder.originWorkOrders = validCodes.map(code => ({
                code,
            }))

            // Update API
            try {
                await API.updateWorkOrderOriginWorkOrders({
                    workOrderId: this.workOrder.id,
                    originWorkOrders: validCodes,
                })
            } catch (error) {
                // If API call fails, revert to original values
                this.$nextTick(() => {
                    this.originWorkOrderCodes = this.sanitizeOriginWorkOrderCodes(
                        this.extractOriginWorkOrderCodes(
                            this.workOrder.originWorkOrders
                        )
                    )
                })
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async updateWarranty() {
            try {
                this.loading = true
                await API.updateReprocessWorkOrder({
                    workOrderId: this.workOrder.id,
                    warranty: this.workOrder.warranty,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openFinishDialog() {
            try {
                if (!this.allItemsProduced()) {
                    this.openForceFinishDialog()
                    return
                }
                this.title = 'Finish'
                this.message =
                    'Are you sure you want to finish this work order ?'
                this.openWarning = true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        processesInitiated() {
            for (const item of this.workOrder.items || []) {
                if (item.production && item.production.length > 0) {
                    return true
                }
            }
            return false
        },
        async deleteFile(file) {
            try {
                this.loading = true
                await deleteFile(
                    file,
                    `${this.companyId}/workOrders/${this.workOrder.id}/attachments`
                )
                this.workOrder.attachments = this.workOrder.attachments.filter(
                    f => f != file
                )
                await API.workOrderAttachments({
                    workOrderId: this.workOrder.id,
                    files: this.workOrder.attachments,
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async openFileAttached(file) {
            try {
                this.loading = true
                await openFile(
                    file,
                    `${this.companyId}/workOrders/${this.workOrder.id}/attachments`
                )
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async saveFile() {
            try {
                this.loadingFiles = true
                await saveFile(
                    this.file,
                    `${this.companyId}/workOrders/${this.workOrder.id}/attachments`
                )
                this.workOrder.attachments = [
                    ...(this.workOrder.attachments || []),
                    this.file.name,
                ]
                await API.workOrderAttachments({
                    workOrderId: this.workOrder.id,
                    files: this.workOrder.attachments,
                })
                this.closeWorkOrderFiles()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loadingFiles = false
            }
        },
        closeWorkOrderFiles() {
            this.workOrderFiles = false
            this.file = null
        },
        openWorkOrderFiles() {
            this.workOrderFiles = true
        },
        closeWarning() {
            this.openWarning = false
        },
        async closeWO() {
            try {
                this.loading = true
                await API.closeWorkOrder({
                    workOrderId: this.workOrder.id,
                    notificationId: 'ar0vX28u4hadZW2pVn9n',
                })
                this.activateAlert = true
                this.alertMessage = 'Work Order Successfully Closed'
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.closeWarning()
            }
        },
        async finishWO() {
            try {
                this.loading = true
                await API.updateWorkOrder({
                    workOrderId: this.workOrder.id,
                    status: 'finished',
                    notificationId: 'pFDh25EcR74EMiuypq8M',
                })
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openForceFinishDialog() {
            this.forceFinishNotesText = ''
            this.forceFinishDialog = true
        },
        async confirmForceFinish() {
            try {
                this.loading = true
                await API.forceFinishWorkOrder({
                    workOrderId: this.workOrder.id,
                    notes: this.forceFinishNotesText.trim(),
                    notificationId: 'pFDh25EcR74EMiuypq8M',
                })
                this.forceFinishDialog = false
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        notFoundFile() {
            let response = false
            for (const item of this.workOrder.items || []) {
                if (
                    !item.files ||
                    !item.files.includes(`${item.partNumber}.pdf`)
                ) {
                    response = true
                    break
                }
            }
            return response
        },
        notItemsCreated() {
            if (this.workOrder.assemblyWorkOrder) {
                return this.workOrder.items &&
                    this.workOrder.items.length > 0 &&
                    this.workOrder.items.every(
                        item =>
                            item.assemblyItems && item.assemblyItems.length > 0
                    )
                    ? false
                    : true
            } else {
                return this.workOrder.items && this.workOrder.items.length > 0
                    ? false
                    : true
            }
        },
        isOriginWorkOrdersRequired() {
            // Si el campo no es requerido, no aplicar la validación
            if (!this.isOriginWorkOrdersFieldRequired) {
                return false
            }

            // Verificar si hay al menos una origin work order seleccionada
            const hasOriginWorkOrders =
                this.originWorkOrderCodes &&
                Array.isArray(this.originWorkOrderCodes) &&
                this.originWorkOrderCodes.length > 0

            // Retornar true si NO hay origin work orders (deshabilitar el botón)
            return !hasOriginWorkOrders
        },
        replaceItem(item) {
            // retrieve data
            if (item.processes && item.processes.length > 0) {
                item.dataProcesses = this.settingProcesses.processes.filter(
                    process => item.processes.includes(process.id)
                )
            }
            if (item.finishAndUCCode) {
                item.dataFinishAndUCCode =
                    this.finishAndUcCodeData[item.finishAndUCCode] || {}
            }
            const index = this.workOrder.items.findIndex(i => i.id == item.id)
            if (index >= 0) {
                this.workOrder.items.splice(index, 1, {
                    ...this.workOrder.items[index],
                    ...item,
                })
                this.workOrder.items = [...this.workOrder.items]
            }
        },
        editItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.createForm = false

            const isApprovedWarrantyWithoutProduction =
                this.workOrder.status === 'approved' &&
                this.workOrder.warranty &&
                (!item.production || item.production.length == 0)

            // If status is 'sent', or 'approved' without warranty exception, open only OC and Position form
            if (
                this.workOrder.status === 'sent' ||
                (this.workOrder.status === 'approved' &&
                    !isApprovedWarrantyWithoutProduction)
            ) {
                this.openOcAndPositionForm = true
            } else if (this.workOrder.assemblyWorkOrder) {
                this.openAssemblyItemForm = true
            } else {
                this.openItemForm = true
            }
        },
        async deleteWorkOrder() {
            try {
                this.loading = true
                await API.deleteWorkOrder(this.workOrder.id)
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDeleteWorkOrder() {
            this.deleteWorkOrderWarning = false
        },
        openDeleteWorkOrder() {
            this.deleteWorkOrderWarning = true
        },
        async copyItem(item) {
            let copiedItem = _.cloneDeep(item)
            delete copiedItem.id
            delete copiedItem.partNumber
            delete copiedItem.partNumberId
            delete copiedItem.dataProcesses
            delete copiedItem.files
            delete copiedItem.dataFinishAndUCCode
            this.selectedItem = _.cloneDeep(copiedItem)
            this.originalItem = _.cloneDeep(copiedItem)
            this.createForm = true
            if (this.workOrder.assemblyWorkOrder) {
                this.openAssemblyItemForm = true
            } else {
                this.openItemForm = true
            }
        },
        async removeItems() {
            if (this.removeAll) {
                await this.deleteAllItems()
            } else {
                await this.deleteItem()
            }
        },
        async deleteAllItems() {
            try {
                this.loading = true
                const validation = this.verifySuggestedQty(this.workOrder.items)
                if (validation) {
                    for (let item of this.workOrder.items) {
                        if (item.files) {
                            for (const file of item.files || []) {
                                await deleteImage(
                                    `${this.companyId}/workOrders/${this.workOrder.id}/items`,
                                    file
                                )
                            }
                        }
                    }
                    await API.deleteWorkOrderAllItems(this.workOrder.id)
                    // remove local item
                    this.workOrder.items = []
                    this.closeDeleteItem()
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async deleteItem() {
            try {
                this.loading = true
                const validation = this.verifySuggestedQty([this.selectedItem])
                if (validation) {
                    await API.deleteWorkOrderItem({
                        workOrderId: this.workOrder.id,
                        partNumberId: this.selectedItem.partNumberId,
                    })
                    if (this.selectedItem.files) {
                        for (const file of this.selectedItem.files) {
                            await deleteImage(
                                `${this.companyId}/workOrders/${this.workOrder.id}/items`,
                                file
                            )
                        }
                    }
                    // remove local item
                    this.workOrder.items = [
                        ...this.workOrder.items.filter(
                            item => item.id != this.selectedItem.id
                        ),
                    ]
                    this.closeDeleteItem()
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeDeleteItem() {
            this.removeAll = false
            this.selectedItem = {}
            this.deleteWarning = false
        },
        openDeleteItem(item) {
            this.removeAll = false
            this.selectedItem = _.cloneDeep(item)
            this.deleteWarning = true
        },
        openDeleteAllItem() {
            this.removeAll = true
            this.deleteWarning = true
        },
        async loadFiles(item, extension) {
            try {
                this.loading = true
                var url = await loadImage(
                    `${this.companyId}/workOrders/${this.workOrder.id}/items`,
                    item.partNumber + '.' + extension
                )
                if (url) {
                    setTimeout(() => {
                        window.open(url, '_blank')
                        this.loading = false
                    })
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        addFiles(newItems) {
            for (const newItem of newItems) {
                const index = this.workOrder.items.findIndex(
                    item => item.id == newItem.itemId
                )
                if (index >= 0) {
                    if (
                        !this.workOrder.items[index].files ||
                        this.workOrder.items[index].files.length === 0
                    ) {
                        this.workOrder.items.splice(index, 1, {
                            ...this.workOrder.items[index],
                            files: newItem.files,
                        })
                    } else {
                        this.workOrder.items.splice(index, 1, {
                            ...this.workOrder.items[index],
                            files: [
                                ...this.workOrder.items[index].files.filter(
                                    file => !newItem.files.includes(file)
                                ),
                                ...newItem.files,
                            ],
                        })
                    }
                }
            }
            this.workOrder.items = [...this.workOrder.items]
            this.closeUploadFiles()
        },
        async addItems(items) {
            try {
                for (const item of items) {
                    this.addItem(item)
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        openPartNumbersNotFound(partNumbers) {
            this.partNumbersNotFound = partNumbers
        },
        async addItem(item) {
            try {
                this.loading = true
                const partNumber = this.partNumbers.find(
                    pn => pn.id === item.partNumberId
                )
                if (partNumber) {
                    item.partNumber = partNumber.code
                }
                // retrieve data
                if (this.settingProcesses?.id) {
                    if (item.processes?.length > 0) {
                        item.dataProcesses = this.settingProcesses.processes.filter(
                            process => item.processes.includes(process.id)
                        )
                    }
                }
                if (this.settingFinish?.id) {
                    if (item.finishAndUCCode) {
                        item.dataFinishAndUCCode =
                            this.finishAndUcCodeData[item.finishAndUCCode] || {}
                    }
                }
                if (!this.workOrder.items) {
                    this.workOrder.items = [item]
                } else {
                    this.workOrder.items.push(item)
                }
                this.workOrder = _.clone(this.workOrder)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openUploadFiles() {
            this.uploadFiles = true
        },
        closeUploadFiles() {
            this.uploadFiles = false
        },
        importFiles() {
            this.openItemFiles = true
        },
        openAddItemFiles(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openItemFiles = true
        },
        closeAddItemFiles() {
            this.selectedItem = {}
            this.originalItem = {}
            this.openItemFiles = false
        },
        openAddItem() {
            this.createForm = true
            if (this.workOrder.assemblyWorkOrder) {
                this.openAssemblyItemForm = true
            } else {
                this.openItemForm = true
            }
        },
        closeAddItem() {
            this.createForm = false
            this.selectedItem = {}
            this.originalItem = {}
            if (this.workOrder.assemblyWorkOrder) {
                this.openAssemblyItemForm = false
            } else {
                this.openItemForm = false
            }
        },
        closeOcAndPositionForm() {
            this.selectedItem = {}
            this.originalItem = {}
            this.openOcAndPositionForm = false
        },
        onResize(retry = true) {
            const { details, buttons, container } = this.$refs || {}
            if (!details || !buttons || !container) {
                if (retry) {
                    this.$nextTick(() => this.onResize(false))
                }
                return
            }
            const { clientHeight: detailsHeight } = details
            const { clientHeight: buttonsHeight } = buttons
            const { clientHeight: containerHeight } = container
            let detailsContainer = this.showWOInfo ? detailsHeight - 200 : -170
            this.height =
                containerHeight -
                detailsContainer -
                buttonsHeight -
                (this.$vuetify.breakpoint.smAndDown ? 350 : 300)
        },
        formatDate(seconds) {
            return `${moment.unix(seconds).format('L')} ${moment
                .unix(seconds)
                .format('LT')}`
        },
        async persistPendingTextFields() {
            await Promise.all([this.saveDescription(), this.saveNotes()])
            // If any field is still dirty, a save failed — abort status change
            if (
                this.prevDescription !== this.workOrder.description ||
                this.prevNotes != this.workOrder.notes
            ) {
                throw new Error(
                    'Failed to save pending work order fields before status change'
                )
            }
        },
        async sendWO() {
            try {
                this.loading = true
                await this.persistPendingTextFields()
                await API.updateWorkOrder({
                    workOrderId: this.workOrder.id,
                    status: 'sent',
                    notificationId: 'sZhuzxwPqvSsy2wFSK66',
                })
                this.activateAlert = true
                this.alertMessage = 'Work Order Successfully Sent for Approval'
                this.$emit('close')
            } catch (error) {
                const notAvailableItems = error?.notAvailablePartNumbers
                if (notAvailableItems?.length > 0) {
                    this.notAvailablePartNumbers = notAvailableItems
                    this.notAvailablePartNumbersDialog = true
                    return
                }
                this.setErrorItems({
                    source: this.$options.name,
                    message: error?.message || 'An error occurred',
                })
            } finally {
                this.loading = false
            }
        },
        async approve() {
            try {
                this.loading = true
                await this.persistPendingTextFields()
                await API.updateWorkOrder({
                    workOrderId: this.workOrder.id,
                    status: 'approved',
                    notificationId: 'pFDh25EcR74EMiuypq8M',
                })
                this.approveWO()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openRejectWO() {
            this.rejectWOForm = true
        },
        closeRejectWO() {
            this.rejectWOForm = false
        },
        async rejectWO() {
            try {
                this.loading = true
                await this.persistPendingTextFields()
                await API.updateWorkOrder({
                    workOrderId: this.workOrder.id,
                    status: 'rejected',
                    rejectedNotes: this.rejectedNotes || '',
                    projectManagerMistake: this.projectManagerMistake,
                    rejectionReason: this.selectedRejectionReason.id,
                    settingId: this.settingRejectionReasonsId,
                    notificationId: 'wu0mfm4lOUmF0G1vdY16',
                })
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
                this.rejectedNotes = undefined
            }
        },
        async saveNotes() {
            if (this.prevNotes == this.workOrder.notes) {
                return
            }
            if (this.notesSavePromise) {
                return this.notesSavePromise
            }
            const notesValue = this.workOrder.notes
            this.pendingWoFieldSaves.notes = true
            this.pendingWoFieldSaves.localValues.notes = notesValue
            this.notesSavePromise = (async () => {
                try {
                    await API.updateWorkOrderNotes({
                        workOrderId: this.workOrder.id,
                        notes: notesValue,
                    })
                    this.prevNotes = notesValue
                } catch (error) {
                    this.setErrorItems({
                        source: this.$options.name,
                        message: error.message,
                    })
                } finally {
                    this.pendingWoFieldSaves.notes = false
                    this.notesSavePromise = null
                }
            })()
            return this.notesSavePromise
        },
        async saveClassification() {
            if (this.prevClassification !== this.workOrder.classification) {
                try {
                    await API.updateWorkOrderClassification({
                        workOrderId: this.workOrder.id,
                        classification: this.workOrder.classification,
                    })
                    this.prevClassification = this.workOrder.classification
                } catch (error) {
                    this.setErrorItems({
                        source: this.$options.name,
                        message: error.message,
                    })
                }
            }
        },
        async saveDescription() {
            if (this.prevDescription === this.workOrder.description) {
                return
            }
            if (this.descriptionSavePromise) {
                return this.descriptionSavePromise
            }
            const descriptionValue = this.workOrder.description
            this.pendingWoFieldSaves.description = true
            this.pendingWoFieldSaves.localValues.description = descriptionValue
            this.descriptionSavePromise = (async () => {
                try {
                    await API.updateWorkOrderDescription({
                        workOrderId: this.workOrder.id,
                        description: descriptionValue,
                    })
                    this.prevDescription = descriptionValue
                } catch (error) {
                    this.setErrorItems({
                        source: this.$options.name,
                        message: error.message,
                    })
                } finally {
                    this.pendingWoFieldSaves.description = false
                    this.descriptionSavePromise = null
                }
            })()
            return this.descriptionSavePromise
        },
        async saveProductType() {
            try {
                this.loading = true
                await API.updateWorkOrderProductType({
                    workOrderId: this.workOrder.id,
                    productType: this.woProductType?.id
                        ? this.woProductType.id
                        : '',
                })
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        openArrangeProcesses(item) {
            this.selectedItem = _.cloneDeep(item)
            this.originalItem = _.cloneDeep(item)
            this.arrangeProcesses = true
        },
        closeArrangeProcesses() {
            this.selectedItem = {}
            this.originalItem = {}
            this.arrangeProcesses = false
        },
        saveProcesses(processes) {
            const itemIndex = this.filterWorkOrders.findIndex(
                i => i.id === this.selectedItem.id
            )
            this.filterWorkOrders[itemIndex].dataProcesses = processes
            this.filterWorkOrders[itemIndex].processes = processes.map(
                process => process.id
            )
            this.closeArrangeProcesses()
            for (let item of this.workOrder.items) {
                item.productionInfo = this.calculateFinished(item)
            }
        },
        sendToPrevProcess(item) {
            this.selectedItem = _.cloneDeep(item)
            this.dialogMaxWidth = '500px'
            this.prevProcessDialog = true
        },
        sendToNextProcess(item) {
            this.selectedItem = _.cloneDeep(item)
            this.sendOperation = true
            this.dialogMaxWidth = '500px'
            this.processDialog = true
        },
        registerProduction(item) {
            this.selectedItem = _.cloneDeep(item)
            this.productionDialog = true
        },
        closeRegisterProduction(items) {
            try {
                this.selectedItem = _.cloneDeep({})
                this.productionDialog = false
                if (items) {
                    items = Object.values(items)
                    items.forEach(item => {
                        const index = this.workOrder.items.findIndex(
                            workOrderItem => workOrderItem.id === item.id
                        )
                        if (index > -1) {
                            this.workOrder.items[index].production =
                                item.production
                            this.workOrder.items[
                                index
                            ].productionInfo = this.calculateFinished(item)
                        }
                    })
                }
                this.multipleRegisterDialog = false
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        closeSendToNextProcess(items) {
            this.selectedItem = _.cloneDeep({})
            this.processDialog = false
            if (items) {
                const entries = Array.isArray(items)
                    ? items
                    : Object.entries(items).map(([partNumberId, data]) => ({
                          partNumberId,
                          ...data,
                      }))
                entries.forEach(item => {
                    const index = this.workOrder.items.findIndex(
                        workOrderItem =>
                            workOrderItem.id === item.id ||
                            workOrderItem.partNumberId === item.partNumberId
                    )
                    if (index > -1) {
                        if (item.deliveries) {
                            this.workOrder.items[index].deliveries =
                                item.deliveries
                        }
                        this.workOrder.items[
                            index
                        ].productionInfo = this.calculateFinished(
                            this.workOrder.items[index]
                        )
                    }
                })
            }
        },
        closeReceiveItemsDialog() {
            this.receiveItemsDialog = false
        },
        closeSendToPrevProcess(items) {
            this.selectedItem = _.cloneDeep({})
            this.prevProcessDialog = false
            if (items) {
                items.forEach(item => {
                    const index = this.workOrder.items.findIndex(
                        workOrderItem => workOrderItem.id === item.id
                    )
                    if (index > -1) {
                        this.workOrder.items[index].deliveries = item.deliveries
                    }
                })
            }
        },
        closePackingDialog(items) {
            this.selectedItem = _.cloneDeep({})
            this.packingDialog = false
            if (items) {
                items.forEach(item => {
                    const index = this.workOrder.items.findIndex(
                        workOrderItem => workOrderItem.id === item.id
                    )
                    if (index > -1) {
                        this.workOrder.items[index].production = item.production
                        this.workOrder.items[
                            index
                        ].productionInfo = this.calculateFinished(item)
                    }
                })
            }
        },
        activateActions(item) {
            return (
                !this.loading &&
                item.processes &&
                Array.isArray(this.user.process) &&
                this.user.process.some(userProc =>
                    item.processes.includes(userProc.id)
                )
            )
        },
        calculateFinished(item) {
            let productionInfo = []

            let qualityProcess = {
                id: this.qualityProcess.id,
                name: this.qualityProcess.name,
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }

            let packingProcess = {
                id: this.packingProcess.id,
                name: this.packingProcess.name,
                qty: 0,
                received: 0,
                delivered: 0,
                produced: 0,
                available: 0,
            }
            if (item && item.processes && this.settingProcesses) {
                if (item.processes) {
                    item.processes.forEach(process => {
                        const pIndex = item.processes.findIndex(
                            p => p == process
                        )

                        let totalProduced = 0
                        let totalDelivered = 0
                        let totalReceived = 0
                        if (item.production) {
                            let production = item.production.filter(
                                register => register.process.id == process
                            )
                            totalProduced = production.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                        if (item.deliveries) {
                            let deliveries = item.deliveries.filter(
                                register => register.prevProcess.id === process
                            )
                            totalDelivered = deliveries.reduce(
                                (total, register) => total + register.qty,
                                0
                            )

                            if (pIndex > 0) {
                                let received = item.deliveries.filter(
                                    register =>
                                        register.nextProcess.id == process &&
                                        register.receivedBy
                                )
                                totalReceived = received.reduce(
                                    (total, register) => total + register.qty,
                                    0
                                )
                            } else {
                                totalReceived = item.quantity
                            }
                        }
                        if (pIndex == 0 && !this.workOrder.assemblyWorkOrder) {
                            totalReceived = item.quantity
                        }

                        if (pIndex == 0 && this.workOrder.assemblyWorkOrder) {
                            totalReceived = item.quantity
                            //TODO: Implement assembly items delivery calculation
                            // if (item.assemblyItems) {
                            //     Object.values(item.assemblyItems).forEach(
                            //         ai => {
                            //             let receivedQty = 0
                            //             if (ai.deliveries) {
                            //                 receivedQty = ai.deliveries.reduce(
                            //                     (accumulator, delivery) =>
                            //                         accumulator + delivery.qty,
                            //                     0
                            //                 )
                            //             }
                            //             const assemblyQty =
                            //                 receivedQty / ai.qtyPerAssembly
                            //             if (assemblyQty < totalReceived) {
                            //                 totalReceived = assemblyQty
                            //             }
                            //         }
                            //     )
                            // }
                        }

                        item.dataProcesses = this.settingProcesses.processes.filter(
                            process => item.processes.includes(process.id)
                        )
                        let processIndex = item.dataProcesses.findIndex(
                            p => p.id == process
                        )
                        if (process == this.qualityProcess.id) {
                            //quality process
                            qualityProcess.qty += item.quantity
                            qualityProcess.delivered = 'NA'
                            qualityProcess.produced =
                                this.calculateRejectedQty(item) +
                                this.calculateReleasedQty(item)
                            qualityProcess.available = this.calculateQualityPending(
                                item
                            )
                            qualityProcess.assemblyProcess = false

                            productionInfo.push(qualityProcess)
                        } else if (process == this.packingProcess.id) {
                            //ready for packing process
                            let received = []
                            if (item.deliveries) {
                                received = item.deliveries.filter(
                                    register =>
                                        register.nextProcess.id == process &&
                                        register.receivedBy
                                )
                            }

                            totalReceived = received.reduce(
                                (total, register) => total + register.qty,
                                0
                            )

                            packingProcess.qty += item.quantity
                            packingProcess.delivered = 'NA'
                            packingProcess.produced += item.packedQty
                            packingProcess.available =
                                totalReceived - (packingProcess.produced || 0)
                            packingProcess.assemblyProcess = false

                            productionInfo.push(packingProcess)
                        } else if (
                            item.qtyInAssembly &&
                            pIndex == item.processes.length - 1
                        ) {
                            productionInfo.push({
                                name: item.dataProcesses[processIndex].name,
                                id: process,
                                produced:
                                    totalReceived > item.qtyInAssembly
                                        ? item.qtyInAssembly
                                        : totalReceived,
                                delivered: totalDelivered,
                                received: totalReceived,
                                available:
                                    totalReceived - item.qtyInAssembly > 0
                                        ? totalReceived - item.qtyInAssembly
                                        : 0,
                                assemblyProcess: item.dataProcesses[
                                    processIndex
                                ].assemblyProcess
                                    ? item.dataProcesses[processIndex]
                                          .assemblyProcess
                                    : false,
                            })
                        } else {
                            productionInfo.push({
                                name: item.dataProcesses[processIndex].name,
                                id: process,
                                produced: totalProduced,
                                delivered: totalDelivered,
                                received: totalReceived,
                                available: totalReceived - totalProduced,
                                assemblyProcess: item.dataProcesses[
                                    processIndex
                                ].assemblyProcess
                                    ? item.dataProcesses[processIndex]
                                          .assemblyProcess
                                    : false,
                            })
                        }
                    })
                }
                if (this.workOrder.assemblyWorkOrder == undefined) {
                    //quality process
                    qualityProcess.qty += item.quantity
                    qualityProcess.delivered = 'NA'
                    qualityProcess.produced =
                        this.calculateRejectedQty(item) +
                        this.calculateReleasedQty(item)
                    qualityProcess.available = this.calculateQualityPending(
                        item
                    )

                    productionInfo.push(qualityProcess)

                    let totalReceivedNew = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.packingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    let totalReceivedOld = item.deliveries
                        ? item.deliveries.reduce(
                              (total, register) =>
                                  register.nextProcess.id ==
                                      this.readyForPackingProcess.id &&
                                  register.receivedBy
                                      ? total + register.qty
                                      : total,
                              0
                          )
                        : 0

                    packingProcess.qty += item.quantity
                    packingProcess.delivered = 'NA'
                    packingProcess.produced += item.packedQty
                    packingProcess.available =
                        totalReceivedOld +
                        totalReceivedNew -
                        (packingProcess.produced || 0)

                    productionInfo.push(packingProcess)
                }
            }
            return productionInfo || []
        },
        async setOrderData() {
            // set processes and finishAndUCCode
            // Get companyId for request (use route query for anonymous users)
            const companyIdForRequest =
                this.user?.name === 'AnonymousSession' &&
                this.$route.query.companyId
                    ? this.$route.query.companyId
                    : this.companyId
            const {
                data: { settings },
            } = await API.getSettings(
                companyIdForRequest ? { companyId: companyIdForRequest } : {}
            )
            this.settingProcesses = settings.find(s => s.name == 'Processes')
            this.settingProcesses.processes.push(
                ...[this.qualityProcess, this.packingProcess]
            )
            this.settingFinish = settings.find(s => s.name == 'FinishAndUCCode')
            // set finish and uc code in keys
            this.finishAndUcCodeData = {}
            this.settingFinish.finishes.forEach(finish => {
                this.finishAndUcCodeData[finish.id] = finish
            })
            this.settingRejectionReasonsId = settings.find(
                s => s.name == 'Quality'
            )?.id
            // get settings rejected reasons
            this.settingsRejectionReasons =
                settings.find(s => s.name == 'Quality')?.rejectionReasons || []
            // get product types ( invoice categories )
            this.productTypes = settings.find(
                setting => setting.name.toLowerCase() == 'invoicing'
            ).categories
            // get name of work order product type
            this.woProductType =
                this.productTypes.find(
                    p => p?.id == this.workOrder?.productType
                )?.name || undefined

            if (this.workOrder.items && this.workOrder.items.length > 0) {
                for (let item of this.workOrder.items) {
                    const label = this.resolveItemPartNumber(item)
                    if (label) {
                        item.partNumber = label
                    }
                    if (this.settingProcesses?.id) {
                        if (item.processes?.length > 0) {
                            item.dataProcesses = this.settingProcesses.processes.filter(
                                process => item.processes.includes(process.id)
                            )
                        }
                    }
                    if (this.settingFinish?.id) {
                        if (item.finishAndUCCode) {
                            item.dataFinishAndUCCode =
                                this.finishAndUcCodeData[
                                    item.finishAndUCCode
                                ] || {}
                        }
                    }
                    item.productionInfo = this.calculateFinished(item)
                }
            }
            this.workOrder.items = [
                ...(this.workOrder.items != undefined
                    ? this.workOrder.items
                    : []),
            ]
            this.initializeOriginWorkOrders()
        },
        resolveItemPartNumber(item) {
            if (item.partNumber) {
                return item.partNumber
            }
            const partNumberId = item.partNumberId || item.id
            const fromWorkOrder = this.workOrder.partNumbers?.[partNumberId]
            if (fromWorkOrder?.partNumber) {
                return fromWorkOrder.partNumber
            }
            const catalogMatch = this.partNumbers.find(
                pn => pn.id === partNumberId || pn.code === partNumberId
            )
            return catalogMatch?.code || ''
        },
        async setUpdatedData() {
            if (this.workOrder.items && this.workOrder.items.length > 0) {
                for (let item of this.workOrder.items) {
                    const label = this.resolveItemPartNumber(item)
                    if (label) {
                        item.partNumber = label
                    }
                    if (this.settingProcesses?.id) {
                        if (item.processes?.length > 0) {
                            item.dataProcesses = this.settingProcesses.processes.filter(
                                process => item.processes.includes(process.id)
                            )
                        }
                    }
                    if (this.settingFinish?.id) {
                        if (item.finishAndUCCode) {
                            item.dataFinishAndUCCode =
                                this.finishAndUcCodeData[
                                    item.finishAndUCCode
                                ] || {}
                        }
                    }
                    item.productionInfo = this.calculateFinished(item)
                }
            }
            this.workOrder.items = [
                ...(this.workOrder.items != undefined
                    ? this.workOrder.items
                    : []),
            ]
            if (this.workOrder.assemblyWorkOrder) {
                this.initializeOriginWorkOrders()
            }
        },
        allItemsCompleted() {
            let itemsCompleted = true
            for (let item of this.workOrder.items) {
                if (item.processes) {
                    for (let process of item.processes) {
                        let totalProduced = 0
                        if (item.production) {
                            let production = item.production.filter(
                                register => register.process.id === process
                            )
                            totalProduced = production.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                        if (totalProduced < item.quantity) {
                            itemsCompleted = false
                            break
                        }
                    }
                }
                if (!itemsCompleted) {
                    break
                }
            }
            return itemsCompleted
        },
        allItemsProduced() {
            let itemsProduced = true
            for (let item of this.workOrder.items) {
                if (item.processes) {
                    for (let process of item.processes) {
                        let totalProduced = 0
                        if (item.production) {
                            let production = item.production.filter(
                                register => register.process.id === process
                            )
                            totalProduced = production.reduce(
                                (total, register) => total + register.qty,
                                0
                            )
                        }
                        if (
                            process ==
                                item.processes[item.processes.length - 1] &&
                            process != this.qualityProcess.id &&
                            process != this.packingProcess.id &&
                            item.deliveries
                        ) {
                            let received = item.deliveries.filter(
                                register =>
                                    register.nextProcess.id == process &&
                                    register.receivedBy
                            )
                            const totalReceived = received.reduce(
                                (total, register) => total + register.qty,
                                0
                            )

                            itemsProduced = totalReceived == item.quantity
                        } else if (
                            totalProduced < item.quantity &&
                            process != this.qualityProcess.id &&
                            process != this.packingProcess.id
                        ) {
                            itemsProduced = false
                            break
                        }
                    }
                }
                if (!itemsProduced) {
                    break
                }
            }
            return itemsProduced
        },
        openMultipleProcesses() {
            this.multipleProcessDialog = true
        },
        closeMultipleProcesses(result) {
            this.multipleProcessDialog = false
            if (!result || !Array.isArray(result.partNumberIds)) {
                return
            }
            const updatedIds = new Set(result.partNumberIds)
            this.workOrder.items = (this.workOrder.items || []).map(item => {
                if (!updatedIds.has(item.partNumberId)) {
                    return item
                }
                const partNumber =
                    this.workOrder.partNumbers &&
                    this.workOrder.partNumbers[item.partNumberId]
                if (partNumber) {
                    this.$set(partNumber, 'processes', result.processes)
                    this.$set(
                        partNumber,
                        'deliveryOptions',
                        result.deliveryOptions
                    )
                }
                const updated = {
                    ...item,
                    processes: result.processes,
                    deliveryOptions: result.deliveryOptions,
                }
                updated.productionInfo = this.calculateFinished(updated)
                return updated
            })
        },
        openMultipleRegister({ forAssemblyOrder = false }) {
            this.forAssemblyOrder = forAssemblyOrder
            this.multipleRegisterDialog = true
        },
        closeMultipleRegister() {
            this.multipleRegisterDialog = false
            this.forAssemblyOrder = false
        },
        openMultipleSend() {
            this.multipleSendDialog = true
        },
        closeMultipleSend(items) {
            this.multipleSendDialog = false
            if (!items) return

            const partNumbersMaps = Array.isArray(items) ? items : [items]
            partNumbersMaps.forEach(partNumbers => {
                if (!partNumbers || typeof partNumbers !== 'object') return
                Object.entries(partNumbers).forEach(([partNumberId, data]) => {
                    const index = this.workOrder.items.findIndex(
                        i => i.partNumberId === partNumberId
                    )
                    if (index > -1 && data.deliveries) {
                        this.workOrder.items[index].deliveries = data.deliveries
                        this.workOrder.items[
                            index
                        ].productionInfo = this.calculateFinished(
                            this.workOrder.items[index]
                        )
                    }
                })
            })
        },
        disableCloseProcess() {
            //TODO: uncomment in update
            return false
            // return this.workOrder.items.some(
            //     item => item.quantity > (item.packedQty || 0)
            // )
        },
        disableFinishProcess() {
            // validate work order production
            let expectedProducedQuantity = 0
            let actualProducedQuantity = 0
            for (let item of this.workOrder.items) {
                // exclude quality and packing processes
                const targetProcesses = item.processes.filter(
                    process =>
                        process != this.qualityProcess.id &&
                        process != this.packingProcess.id
                )
                // get expected produced quantity
                expectedProducedQuantity +=
                    item.quantity * targetProcesses.length

                // get actual produced quantity
                if (item.productionInfo?.length > 0) {
                    actualProducedQuantity += item.productionInfo.reduce(
                        (total, production) => {
                            const produced = +production.produced || 0
                            return total + produced
                        },
                        0
                    )
                }
            }

            return expectedProducedQuantity > actualProducedQuantity
        },
        registerQuality(item) {
            this.selectedItem = _.cloneDeep(item)
            this.qualityDialog = true
        },
        closeQualityProcess() {
            this.selectedItem = _.cloneDeep({})
            this.qualityDialog = false
        },
        openMultipleQuality() {
            this.multipleQualityDialog = true
        },
        closeMultipleQualityProcess() {
            this.multipleQualityDialog = false
        },
        calculateQualityPending(item) {
            try {
                let pendingQty = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    let lastProcessIndex = item.processes.length - 1
                    if (this.workOrder.assemblyWorkOrder != undefined) {
                        lastProcessIndex =
                            item.processes.findIndex(
                                p => p == this.qualityProcess.id
                            ) - 1
                    }
                    if (lastProcessIndex > -1) {
                        const lastProductionProcess =
                            item.processes[lastProcessIndex]
                        if (item.production) {
                            const production = item.production.filter(
                                entry =>
                                    entry.process.id == lastProductionProcess
                            )
                            if (production.length > 0) {
                                pendingQty = production.reduce(
                                    (accumulator, entry) =>
                                        accumulator + entry.qty,
                                    0
                                )
                            }
                        }
                        if (item.quality) {
                            const rejected = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.rejectQty || 0),
                                0
                            )
                            const released = item.quality.reduce(
                                (accumulator, entry) =>
                                    accumulator + (entry.releaseQty || 0),
                                0
                            )
                            pendingQty -=
                                Number(released || 0) + Number(rejected || 0)
                        }
                    }
                } else {
                    pendingQty = -1
                }

                return pendingQty
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReleasedQty(item) {
            try {
                let released = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        released += Number(value || 0)
                    }
                } else {
                    released = -1
                }

                return released
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateReprocessQty(item) {
            try {
                let reprocess = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.reprocessQty || 0),
                            0
                        )
                        reprocess += Number(value || 0)
                    }
                } else {
                    reprocess = -1
                }
                return reprocess
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        calculateRejectedQty(item) {
            try {
                let rejected = 0
                if (
                    item.processes.includes(this.qualityProcess.id) ||
                    this.workOrder.assemblyWorkOrder == undefined
                ) {
                    if (item.quality) {
                        const value = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        rejected += Number(value || 0)
                    }
                } else {
                    rejected = -1
                }
                return rejected
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        openProductionLog(item) {
            this.selectedItem = _.cloneDeep(item)
            this.viewType = 'production'
            this.itemLogDialog = true
        },
        openDeliveryLog(item) {
            this.selectedItem = _.cloneDeep(item)
            this.viewType = 'delivery'
            this.itemLogDialog = true
        },
        openQualityLog(item) {
            this.selectedItem = _.cloneDeep(item)
            this.viewType = 'quality'
            this.itemLogDialog = true
        },
        filterByPartNumber(item) {
            return item.partNumber
                .toLowerCase()
                .includes(this.partNumberToFilter.toLowerCase())
        },
        filterByProcess(item) {
            let processesString = ''
            item.dataProcesses.forEach(process => {
                if (item.processes.includes(process.id)) {
                    processesString += ` ${process.name}`
                }
            })
            return processesString
                .toLowerCase()
                .includes(this.processToFilter.toLowerCase())
        },
        sort(items) {
            if (this.user.process) {
                const process = this.user.process.id

                if (this.sortByAvailable) {
                    items.sort((a, b) => {
                        const productionA = a.productionInfo.find(
                            p => p.id === process
                        )
                        const productionB = b.productionInfo.find(
                            p => p.id === process
                        )
                        return (
                            (productionB?.available || 0) -
                            (productionA?.available || 0)
                        )
                    })
                } else if (this.sortByProduced) {
                    items.sort((a, b) => {
                        const productionA = a.productionInfo.find(
                            p => p.id === process
                        )
                        const productionB = b.productionInfo.find(
                            p => p.id === process
                        )
                        return (
                            (productionB?.produced || 0) -
                            (productionA?.produced || 0)
                        )
                    })
                } else if (this.sortByDelivered) {
                    items.sort((a, b) => {
                        const productionA = a.productionInfo.find(
                            p => p.id === process
                        )
                        const productionB = b.productionInfo.find(
                            p => p.id === process
                        )
                        return (
                            (productionB?.delivered || 0) -
                            (productionA?.delivered || 0)
                        )
                    })
                }
            }

            if (this.sortByPending) {
                items.sort((a, b) => {
                    return (
                        (this.calculateQualityPending(b) || 0) -
                        (this.calculateQualityPending(a) || 0)
                    )
                })
            } else if (this.sortByReleased) {
                items.sort((a, b) => {
                    return (
                        (this.calculateReleasedQty(b) || 0) -
                        (this.calculateReleasedQty(a) || 0)
                    )
                })
            } else if (this.sortByReprocess) {
                items.sort((a, b) => {
                    return (
                        (this.calculateReprocessQty(b) || 0) -
                        (this.calculateReprocessQty(a) || 0)
                    )
                })
            } else if (this.sortByRejected) {
                items.sort((a, b) => {
                    return (
                        (this.calculateRejectedQty(b) || 0) -
                        (this.calculateRejectedQty(a) || 0)
                    )
                })
            }

            return items
        },
        closeDialog() {
            this.$emit('close')
        },
        openReceiveItems() {
            this.dialogMaxWidth = '1000px'
            this.receiveItemsDialog = true
        },
        openTypeDialog() {
            this.typeDialog = true
        },
        closeTypeDialog() {
            this.typeDialog = false
        },
        async updateWorkOrderType() {
            try {
                this.loading = true
                const value = this.workOrderType == 'Production' ? false : true
                await API.updateWorkOrderType({
                    workOrderId: this.workOrder.id,
                    assemblyWorkOrder: value,
                })
                this.workOrder.assemblyWorkOrder = value
                this.closeTypeDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        showInformation() {
            this.showWOInfo = !this.showWOInfo
            this.$nextTick(() => {
                this.onResize()
            })
        },
        async warningAction() {
            if (this.title == 'Finish') {
                await this.finishWO()
            }
        },
        closeWoClosingProcess(closeDetailView = false) {
            this.closingDialog = false
            if (closeDetailView) {
                this.closeDialog()
            }
        },
        async returnToApproved() {
            try {
                this.loading = true
                await API.returnWorkOrderToApproved({
                    workOrderId: this.workOrder.id,
                })
                this.returnToApprovedDialog = false
                this.$emit('close')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        closeSuggestedQtyWarning() {
            this.suggestedQtyAlerts = []
            this.suggestedQtyWarning = false
            this.closeDeleteItem()
        },
        verifySuggestedQty(items) {
            try {
                this.loading = true
                this.suggestedQtyAlerts = []
                if (Object.keys(this.suggestedQtysPerPl).length > 0) {
                    for (const [code, value] of Object.entries(
                        this.suggestedQtysPerPl
                    )) {
                        if (items.length > 0) {
                            items.forEach(item => {
                                if (value[item.partNumberId] > 0) {
                                    this.suggestedQtyAlerts.push({
                                        partNumber: item.partNumber,
                                        code: code,
                                        value: value[item.partNumberId],
                                    })
                                }
                            })
                        }
                    }
                }
                if (this.suggestedQtyAlerts.length > 0) {
                    this.suggestedQtyWarning = true
                    return false
                }
                return true
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        showAssemblyInformation() {
            this.assemblyInfoDialog = !this.assemblyInfoDialog
        },
        closeAssemblyInformation() {
            this.assemblyInfoDialog = false
        },
        openAlertsDialog() {
            this.alertsDialog = true
        },
        openCreateAlertDialog() {
            this.selectedAlert = null
            this.alertFormDialog = true
            this.alertsDialog = false
        },
        handleEditAlertFromList(alert) {
            this.alertsDialog = false
            this.editAlert(alert)
        },
        handleResolveAlertFromList(alert) {
            this.alertsDialog = false
            this.openResolveDialog(alert)
        },
        handleMakeChangesAlertFromList(alert) {
            this.openMakeChangesDialog(alert).then(() => {
                if (this.makeChangesDialog) {
                    this.alertsDialog = false
                }
            })
        },
        handleApproveAlertFromList(alert) {
            this.alertsDialog = false
            this.openApproveDialog(alert)
        },
        handleDeleteAlertFromList(alert) {
            this.alertsDialog = false
            this.openDeleteAlertDialog(alert)
        },
        handleDeleteNonExecutableAlertFromList(alert) {
            this.alertsDialog = false
            this.openDeleteNonExecutableDialog(alert)
        },
        reloadAlerts() {
            if (
                this.$refs.alertsList &&
                typeof this.$refs.alertsList.reload === 'function'
            ) {
                this.$refs.alertsList.reload()
            }
        },
        async cleanProductionFields() {
            try {
                this.loadingCleanFields = true
                const result = await API.cleanProductionFields({
                    workOrderId: this.workOrder.id,
                })
                this.activateAlert = true
                this.alertMessage =
                    result.message || 'Production fields cleaned successfully'
                // Recargar los datos de la work order si es necesario
                this.$emit('refresh')
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loadingCleanFields = false
            }
        },
        async copyQRLink() {
            try {
                await navigator.clipboard.writeText(this.qrLink)
                this.activateAlert = true
                this.alertMessage = 'Link copied to clipboard'
            } catch (error) {
                // Fallback for older browsers
                const textArea = document.createElement('textarea')
                textArea.value = this.qrLink
                textArea.style.position = 'fixed'
                textArea.style.left = '-999999px'
                document.body.appendChild(textArea)
                textArea.select()
                try {
                    document.execCommand('copy')
                    this.activateAlert = true
                    this.alertMessage = 'Link copied to clipboard'
                } catch (err) {
                    console.error('Failed to copy link', err)
                }
                document.body.removeChild(textArea)
            }
        },
    },
}
</script>

<style>
#virtual-scroll-table {
    width: 100%;
    overflow: auto;
}

.selected-item {
    background-color: #dff0ff;
}

.alert-open-row {
    background-color: #fff9e6 !important;
}
.alert-resolved-row {
    background-color: #e6f3ff !important;
}
.alert-pending-approval-row {
    background-color: #f3e5f5 !important;
}
</style>
